/* GriGsi SENDi! shell deps — built by scripts/build-sendi-shell-deps.js — do not edit */
/**
 * GriGsi Space server channel — same principle as browser extensions:
 * WebSocket /ws?surface=space for live_message + signal_warning push;
 * GET /signal-warnings?platform=space + GET /emergency for bootstrap;
 * org live via GET /api/sendi/:code/org-live (priority over global).
 */
(function () {
  'use strict';

  var LIVE_COLOR = '#F08B83';
  var LIVE_BANNER_ID = 'grigsi-space-live-banner';
  var SIGNAL_ROWS_URL = '/signal-warnings?platform=all';
  var SIGNAL_BANNER_ID = 'grigsi-space-signal-banner';
  var IDENTIFIER_COLOR = '#3D2860';
  var REPORT_SESSION_KEY = 'grigsi_space_wm_reported_row';
  var WS_RECONNECT_MS = 10000;
  var WS_INITIAL_DELAY_MS = 2000;
  var WS_MAX_BACKOFF_MS = 5 * 60 * 1000;
  var WS_MAX_ATTEMPTS = 6; // give up (until next page load) after this many consecutive failures
  var SIGNAL_REFRESH_MS = 5 * 60 * 1000;
  var EMERGENCY_REFRESH_MS = 120000;
  var ORG_LIVE_REFRESH_MS = 60000;

  var wsLiveActive = false;
  var wsLivePayload = null;
  var emergencyActive = false;
  var emergencyPayload = null;
  var orgLiveActive = false;
  var orgLivePayload = null;
  var lastOrgLiveRaw = null;
  var lastSignalJson = '';
  var wsReconnectTimer = null;
  var wsBackoffMs = WS_RECONNECT_MS;
  var wsFailedAttempts = 0;
  var ttsTimer = null;
  var ttsPlaysLeft = 0;

  function $(id) {
    return document.getElementById(id);
  }

  function getSpaceCode() {
    if (typeof window.__grigsiSpaceKey === 'string' && /^[a-f0-9]{64}$/i.test(window.__grigsiSpaceKey)) {
      return String(window.__grigsiSpaceKey).trim().toLowerCase();
    }
    var p = new URLSearchParams(window.location.search);
    var raw = p.get('space') || p.get('code') || '';
    raw = String(raw || '').trim();
    if (/^[a-f0-9]{64}$/i.test(raw)) return raw.toLowerCase();
    raw = raw.toUpperCase().replace(/[^A-Z0-9-]/g, '');
    if (raw.indexOf('GRIGSI') === 0 && raw.length > 6) raw = raw.slice(6, 18);
    if (raw) return raw;
    var el = $('space-code');
    if (el && el.value) return String(el.value).trim().toUpperCase();
    return '';
  }

  function getSignalSlot() {
    return $('space-signal-slot') || document.body;
  }

  function getLiveSlot() {
    return $('space-live-slot') || document.body;
  }

  function getHost() {
    return $('space-watermark-host') || document.body;
  }

  function measureChannelOverlay() {
    var el = $('space-channel-overlay');
    if (!el) return;
    var h = Math.ceil(el.getBoundingClientRect().height);
    if (h > 0) {
      document.documentElement.style.setProperty('--space-channel-overlay-height', h + 'px');
    }
  }

  function scheduleChannelOverlayMeasure() {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(measureChannelOverlay);
    } else {
      setTimeout(measureChannelOverlay, 0);
    }
  }

  function wireChannelOverlayMeasure() {
    measureChannelOverlay();
    window.addEventListener('resize', measureChannelOverlay);
    if (typeof ResizeObserver !== 'undefined') {
      var overlay = $('space-channel-overlay');
      if (overlay) {
        var ro = new ResizeObserver(scheduleChannelOverlayMeasure);
        ro.observe(overlay);
      }
    }
  }

  function scopeOpacity(scope) {
    if (scope <= 0) return 0.08;
    if (scope === 1) return 0.15;
    if (scope === 2) return 0.22;
    if (scope === 3) return 0.3;
    return 0.38;
  }

  function emergencyTargetsSpace(platforms) {
    if (!platforms || typeof platforms !== 'object') return true;
    if (platforms.all || platforms.space) return true;
    if (!platforms.extension && !platforms.windows && !platforms.android && !platforms.space) return true;
    return false;
  }

  function ensureSignalStyles() {
    if (document.getElementById('grigsi-space-signal-styles')) return;
    var style = document.createElement('style');
    style.id = 'grigsi-space-signal-styles';
    style.textContent =
      '@keyframes grigsi-space-g-sway{0%,100%{transform:rotate(-5deg)}50%{transform:rotate(5deg)}}' +
      '@keyframes grigsi-space-arc-run{0%,100%{transform:scale(1)}50%{transform:scale(1.35)}}' +
      '#grigsi-space-signal-banner .grigsi-space-g-sway{animation:grigsi-space-g-sway 1.4s ease-in-out infinite;display:inline-block}' +
      '#grigsi-space-signal-banner .grigsi-space-arc-run{animation:grigsi-space-arc-run 1.4s ease-in-out infinite;display:inline-block}' +
      '#grigsi-space-signal-banner{position:relative;bottom:auto;right:auto;left:auto;z-index:auto;display:flex;align-items:center;justify-content:flex-start;gap:4px;' +
      'font-size:14px;font-weight:700;font-family:Inter,system-ui,-apple-system,sans-serif;color:#3D2860;' +
      'pointer-events:none;user-select:none;opacity:1;transition:opacity 2s ease;max-width:100%;flex-shrink:0}' +
      '#grigsi-space-signal-banner.grigsi-space-signal-banner--faded{opacity:0.92}' +
      '#grigsi-space-signal-banner .grigsi-space-signal-media{max-height:28px;max-width:72px;object-fit:contain;margin-left:6px}';
    document.head.appendChild(style);
  }

  function removeSignalBanner() {
    var el = document.getElementById(SIGNAL_BANNER_ID);
    if (el) el.remove();
    var legacy = $('space-watermark-overlay');
    if (legacy) {
      legacy.innerHTML = '';
      legacy.classList.remove('space-watermark-overlay--visible', 'space-watermark-overlay--channel');
    }
  }

  function appendGgPair(banner) {
    var g1 = document.createElement('span');
    g1.textContent = 'G';
    g1.style.color = '#A693EF';
    g1.className = 'grigsi-space-g-sway';
    var mid = document.createElement('span');
    mid.textContent = '‿';
    mid.style.color = '#F08B83';
    mid.style.margin = '0 2px';
    mid.className = 'grigsi-space-arc-run';
    var g2 = document.createElement('span');
    g2.textContent = 'G';
    g2.style.color = '#A693EF';
    g2.className = 'grigsi-space-g-sway';
    banner.appendChild(g1);
    banner.appendChild(mid);
    banner.appendChild(g2);
  }

  function appendMedia(banner, url) {
    if (!url) return;
    var isVideo = /\.(mp4|webm|ogg|ogv|mov|avi|m4v)$/i.test(url);
    if (isVideo) {
      var vid = document.createElement('video');
      vid.src = url;
      vid.muted = true;
      vid.loop = true;
      vid.playsInline = true;
      vid.autoplay = true;
      vid.className = 'grigsi-space-signal-media';
      vid.play().catch(function () {});
      banner.appendChild(vid);
    } else {
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.className = 'grigsi-space-signal-media';
      img.referrerPolicy = 'no-referrer';
      img.onerror = function () { img.remove(); };
      banner.appendChild(img);
    }
  }

  function scheduleSignalFade(banner) {
    setTimeout(function () {
      if (banner && banner.parentNode) banner.classList.add('grigsi-space-signal-banner--faded');
    }, 3000);
  }

  function renderSignalBanner(row) {
    ensureSignalStyles();
    removeSignalBanner();
    if (!shouldRender(row)) return;

    var scopeRaw = row.watermarkScope != null ? parseInt(String(row.watermarkScope), 10) : 1;
    var scope = Number.isNaN(scopeRaw) ? 1 : Math.min(5, Math.max(0, scopeRaw));
    if (scope === 0) return;

    var text = String(row.text != null ? row.text : '').trim();
    var url = row.attachment_url && String(row.attachment_url).trim() ? String(row.attachment_url).trim() : null;
    var urlGrigsi = row.attachment_url_grigsi && String(row.attachment_url_grigsi).trim() ? String(row.attachment_url_grigsi).trim() : null;
    var urlGg = row.attachment_url_gg && String(row.attachment_url_gg).trim() ? String(row.attachment_url_gg).trim() : null;

    var banner = document.createElement('div');
    banner.id = SIGNAL_BANNER_ID;
    var sid = row.signalRowId != null ? row.signalRowId : row.adId;
    if (sid != null) banner.dataset.signalRowId = String(sid);

    if (scope === 1) {
      if (url) {
        appendMedia(banner, url);
      } else if (text) {
        var only = document.createElement('span');
        only.textContent = text;
        only.style.color = IDENTIFIER_COLOR;
        banner.appendChild(only);
      } else {
        return;
      }
    } else if (scope === 2) {
      if (urlGrigsi) appendMedia(banner, urlGrigsi);
      else if (text) {
        var t2 = document.createElement('span');
        t2.textContent = text;
        t2.style.color = IDENTIFIER_COLOR;
        t2.style.marginRight = '4px';
        banner.appendChild(t2);
      } else {
        var gLabel = document.createElement('span');
        gLabel.textContent = 'GriGsi';
        gLabel.style.color = IDENTIFIER_COLOR;
        gLabel.style.marginRight = '4px';
        banner.appendChild(gLabel);
      }
      if (urlGg) appendMedia(banner, urlGg);
      else appendGgPair(banner);
    } else {
      var left = document.createElement('span');
      left.textContent = 'GriGsi';
      left.style.color = IDENTIFIER_COLOR;
      left.style.marginRight = '4px';
      banner.appendChild(left);
      if (url || urlGg) appendMedia(banner, url || urlGg);
      else if (text) {
        var t3 = document.createElement('span');
        t3.textContent = text;
        t3.style.color = IDENTIFIER_COLOR;
        banner.appendChild(t3);
      } else {
        appendGgPair(banner);
      }
    }

    getSignalSlot().appendChild(banner);
    scheduleSignalFade(banner);
    scheduleChannelOverlayMeasure();
  }

  function shouldRender(row) {
    if (!row || typeof row !== 'object') return false;
    var scopeRaw = row.watermarkScope != null ? parseInt(String(row.watermarkScope), 10) : 1;
    var scope = Number.isNaN(scopeRaw) ? 1 : Math.min(5, Math.max(0, scopeRaw));
    var text = String(row.text != null ? row.text : '').trim();
    var url = row.attachment_url && String(row.attachment_url).trim();
    if (scope === 0 && !text && !url) return false;
    return true;
  }

  function isPreviewContainer(container) {
    if (!container) return false;
    if (container.id === 'space-admin-watermark-preview') return true;
    return container.classList && container.classList.contains('space-admin-watermark-preview');
  }

  function renderInto(container, row) {
    if (!container) return;
    var preview = isPreviewContainer(container);
    if (!shouldRender(row)) {
      container.innerHTML = '';
      container.classList.remove('space-watermark-overlay--visible');
      if (preview) {
        container.classList.add('space-admin-watermark-preview--empty');
        container.classList.remove('space-admin-watermark-preview--filled');
      }
      return;
    }
    var scopeRaw = row.watermarkScope != null ? parseInt(String(row.watermarkScope), 10) : 1;
    var scope = Number.isNaN(scopeRaw) ? 1 : Math.min(5, Math.max(0, scopeRaw));
    var text = String(row.text != null ? row.text : '').trim() || 'GriGsi';
    var url = row.attachment_url && String(row.attachment_url).trim() ? String(row.attachment_url).trim() : null;

    container.innerHTML = '';
    var inner = document.createElement('div');
    inner.className = preview ? 'space-admin-watermark-inner' : 'space-watermark-inner';
    if (url) {
      var img = document.createElement('img');
      img.src = url;
      img.alt = '';
      img.className = preview ? 'space-admin-watermark-img' : 'space-watermark-img';
      img.referrerPolicy = 'no-referrer';
      inner.appendChild(img);
    }
    var span = document.createElement('div');
    span.className = preview ? 'space-admin-watermark-text' : 'space-watermark-text';
    span.textContent = text;
    inner.appendChild(span);
    container.appendChild(inner);
    container.dataset.scope = String(scope);
    var sid = row.signalRowId != null ? row.signalRowId : row.adId;
    container.dataset.signalRowId = sid != null ? String(sid) : '';
    if (preview) {
      container.classList.remove('space-admin-watermark-preview--empty');
      container.classList.add('space-admin-watermark-preview--filled');
    }
  }

  function createOverlayEl() {
    return $('space-watermark-overlay');
  }

  function maybeReportPlay(row) {
    if (!row) return;
    var rawId = row.signalRowId != null ? row.signalRowId : row.adId;
    if (rawId == null) return;
    var id = parseInt(String(rawId), 10);
    if (!(id > 0)) return;
    var scopeRaw = row.watermarkScope != null ? parseInt(String(row.watermarkScope), 10) : 1;
    var scope = Number.isNaN(scopeRaw) ? 1 : Math.min(5, Math.max(0, scopeRaw));
    if (scope === 0) return;
    try {
      if (sessionStorage.getItem(REPORT_SESSION_KEY) === String(id)) return;
    } catch (_) {}
    fetch('/report-signal-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ signalRowId: id }),
    })
      .then(function () {
        try {
          sessionStorage.setItem(REPORT_SESSION_KEY, String(id));
        } catch (_) {}
      })
      .catch(function () {});
  }

  function renderDefaultIdentifierStrip() {
    renderSignalBanner({ watermarkScope: 2, text: '', signalRowId: 'default' });
  }

  function applyOverlaySignals(list) {
    if (!Array.isArray(list) || list.length === 0) {
      lastSignalJson = '';
      renderDefaultIdentifierStrip();
      var preview = $('space-admin-watermark-preview');
      if (preview) {
        preview.innerHTML = '<span class="space-admin-watermark-placeholder">No active overlay signals.</span>';
        preview.classList.add('space-admin-watermark-preview--empty');
        preview.classList.remove('space-admin-watermark-preview--filled');
      }
      return;
    }
    var row = list[0];
    try {
      var j = JSON.stringify(row);
      if (j === lastSignalJson) return;
      lastSignalJson = j;
    } catch (_) {}

    renderSignalBanner(row);
    maybeReportPlay(row);

    var preview = $('space-admin-watermark-preview');
    if (preview) renderInto(preview, row);
  }

  function applySignalFromWs(msg) {
    if (!msg || typeof msg !== 'object') return;
    applyOverlaySignals([{
      signalRowId: msg.signalRowId != null ? msg.signalRowId : msg.adId,
      text: msg.text,
      watermarkScope: msg.watermarkScope,
      attachment_url: msg.attachment_url,
      attachment_url_grigsi: msg.attachment_url_grigsi,
      attachment_url_community: msg.attachment_url_community,
      attachment_url_gg: msg.attachment_url_gg,
      animationDisplay: msg.animationDisplay,
      attachmentPosition: msg.attachmentPosition,
    }]);
  }

  function clearSignalOverlay() {
    lastSignalJson = '';
    renderDefaultIdentifierStrip();
  }

  function stopTts() {
    if (ttsTimer) {
      clearTimeout(ttsTimer);
      ttsTimer = null;
    }
    ttsPlaysLeft = 0;
    try {
      if (window.speechSynthesis) window.speechSynthesis.cancel();
    } catch (_) {}
  }

  function startTts(text, lang, enabled, plays) {
    stopTts();
    if (!enabled || !text || !window.speechSynthesis) return;
    var count = typeof plays === 'number' && plays >= 0 ? Math.floor(plays) : 0;
    if (count <= 0) return;
    ttsPlaysLeft = count;
    function speakOnce() {
      if (ttsPlaysLeft <= 0) return;
      ttsPlaysLeft -= 1;
      try {
        var u = new SpeechSynthesisUtterance(text);
        u.lang = lang || 'bg-BG';
        u.onend = function () {
          if (ttsPlaysLeft > 0) ttsTimer = setTimeout(speakOnce, 800);
        };
        window.speechSynthesis.speak(u);
      } catch (_) {}
    }
    speakOnce();
  }

  function removeLiveBanner() {
    stopTts();
    document.querySelectorAll('#' + LIVE_BANNER_ID).forEach(function (el) {
      el.remove();
    });
    var styleEl = document.getElementById('grigsi-space-live-style');
    if (styleEl) styleEl.remove();
  }

  function showLive(payload) {
    if (!payload) return;
    var text = typeof payload.text === 'string' ? payload.text : (typeof payload.message === 'string' ? payload.message : 'Notice');
    var color = payload.color || LIVE_COLOR;
    var attachmentUrl = payload.attachmentUrl || payload.attachment_url || null;
    if (attachmentUrl) attachmentUrl = String(attachmentUrl).trim() || null;
    var attachmentType = payload.attachmentType;
    if (!attachmentType && attachmentUrl) {
      attachmentType = /\.(mp4|webm|ogg|ogv|mov|avi|m4v)$/i.test(attachmentUrl) ? 'video' : 'image';
    }
    var mode = payload.mode === 'static' ? 'static' : 'moving';
    var staticOffset = payload.static_offset_px != null ? Math.max(0, Math.min(500, parseInt(payload.static_offset_px, 10) || 20)) : 20;
    var audio = !!payload.audio;
    var audioLang = ['bg-BG', 'en-US', 'fr-FR', 'es-ES', 'it-IT', 'ja-JP', 'de-DE', 'zh-CN'].indexOf(payload.audio_lang) >= 0 ? payload.audio_lang : 'bg-BG';
    var audioPlays = typeof payload.audio_plays === 'number' && payload.audio_plays >= 0 ? payload.audio_plays : 1;

    removeLiveBanner();

    var track = document.createElement('div');
    track.id = LIVE_BANNER_ID;
    track.className = 'grigsi-space-live-banner';
    if (mode === 'static') {
      track.classList.add('grigsi-space-live-banner--static');
    } else {
      track.classList.add('grigsi-space-live-banner--moving');
    }
    track.style.color = color;

    var seg = document.createElement('span');
    seg.className = 'grigsi-space-live-banner__text';
    seg.textContent = text || 'Notice';
    track.appendChild(seg);

    if (attachmentUrl) {
      if (attachmentType === 'video') {
        var vid = document.createElement('video');
        vid.src = attachmentUrl;
        vid.muted = true;
        vid.loop = true;
        vid.playsInline = true;
        vid.autoplay = true;
        vid.className = 'grigsi-space-live-banner__media';
        vid.play().catch(function () {});
        track.appendChild(vid);
      } else {
        var img = document.createElement('img');
        img.src = attachmentUrl;
        img.alt = '';
        img.className = 'grigsi-space-live-banner__media';
        img.referrerPolicy = 'no-referrer';
        img.onerror = function () { img.remove(); };
        track.appendChild(img);
      }
    }

    getLiveSlot().appendChild(track);
    startTts(text, audioLang, audio, audioPlays);
    scheduleChannelOverlayMeasure();
  }

  function hideLive() {
    removeLiveBanner();
    scheduleChannelOverlayMeasure();
  }

  function pushLiveUi() {
    if (orgLiveActive && orgLivePayload) {
      showLive(orgLivePayload);
      return;
    }
    if (wsLiveActive && wsLivePayload) {
      showLive(wsLivePayload);
      return;
    }
    if (emergencyActive && emergencyPayload) {
      showLive(emergencyPayload);
      return;
    }
    hideLive();
  }

  function parseLiveWsMessage(msg) {
    var text = typeof msg.message === 'string' ? msg.message : '';
    var attachmentUrl = (msg.attachmentUrl && String(msg.attachmentUrl).trim()) || (msg.attachment_url && String(msg.attachment_url).trim()) || null;
    var attachmentType = msg.attachmentType || (attachmentUrl && /\.(mp4|webm|ogg|ogv|mov|avi|m4v)$/i.test(attachmentUrl) ? 'video' : 'image');
    return {
      text: text || 'Notice',
      color: LIVE_COLOR,
      audio: !!msg.audio,
      audio_lang: msg.audio_lang,
      audio_plays: typeof msg.audio_plays === 'number' ? msg.audio_plays : 1,
      attachmentUrl: attachmentUrl || undefined,
      attachmentType: attachmentUrl ? attachmentType : undefined,
      mode: msg.mode === 'static' ? 'static' : 'moving',
      static_offset_px: msg.mode === 'static' && msg.static_offset_px != null ? msg.static_offset_px : 20,
    };
  }

  function fetchSignals() {
    fetch(SIGNAL_ROWS_URL, { cache: 'no-store' })
      .then(function (res) {
        return res.ok ? res.json() : [];
      })
      .then(function (list) {
        applyOverlaySignals(Array.isArray(list) ? list : []);
      })
      .catch(function () {});
  }

  function fetchEmergency() {
    fetch('/emergency?t=' + Date.now(), { cache: 'no-store' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        if (!data || typeof data !== 'object') return;
        if (!data.enabled || !emergencyTargetsSpace(data.platforms)) {
          emergencyActive = false;
          emergencyPayload = null;
        } else {
          var attachmentUrl = data.attachment_url && String(data.attachment_url).trim() ? String(data.attachment_url).trim() : null;
          emergencyActive = true;
          emergencyPayload = {
            text: data.message || 'Notice',
            color: LIVE_COLOR,
            audio: !!data.audio,
            audio_lang: data.audio_lang,
            audio_plays: data.audio_plays,
            attachmentUrl: attachmentUrl || undefined,
            mode: data.mode === 'static' ? 'static' : 'moving',
            static_offset_px: data.static_offset_px,
          };
        }
        if (!wsLiveActive) pushLiveUi();
      })
      .catch(function () {});
  }

  function fetchOrgLive() {
    var code = getSpaceCode();
    if (!code) {
      orgLiveActive = false;
      orgLivePayload = null;
      pushLiveUi();
      return;
    }
    fetch('/api/sendi/' + encodeURIComponent(code) + '/org-live?t=' + Date.now(), { cache: 'no-store' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (data) {
        lastOrgLiveRaw = data;
        try {
          document.dispatchEvent(new CustomEvent('grigsi-org-live-data', { detail: data }));
        } catch (_) {}
        if (!data || typeof data !== 'object' || !data.live_active) {
          orgLiveActive = false;
          orgLivePayload = null;
        } else {
          var attachmentUrl = data.live_attachment_url && String(data.live_attachment_url).trim() ? String(data.live_attachment_url).trim() : null;
          orgLiveActive = true;
          orgLivePayload = {
            text: data.live_message || 'Notice',
            color: LIVE_COLOR,
            audio: !!data.live_audio,
            audio_lang: data.live_audio_lang,
            audio_plays: data.live_audio_plays,
            attachmentUrl: attachmentUrl || undefined,
            mode: data.live_mode === 'static' ? 'static' : 'moving',
          };
        }
        pushLiveUi();
      })
      .catch(function () {});
  }

  function handleWsMessage(msg) {
    if (!msg || !msg.type) return;
    if (msg.type === 'restore_watermark' || msg.type === 'restore_ad' || msg.type === 'restore_signal_warning') {
      wsLiveActive = false;
      wsLivePayload = null;
      hideLive();
      clearSignalOverlay();
      fetchSignals();
      pushLiveUi();
    } else if (msg.type === 'ad' || msg.type === 'signal_warning') {
      applySignalFromWs(msg);
    } else if (msg.type === 'live_off') {
      wsLiveActive = false;
      wsLivePayload = null;
      pushLiveUi();
    } else if (msg.type === 'live_message' || msg.type === 'broadcast_message') {
      wsLiveActive = true;
      wsLivePayload = parseLiveWsMessage(msg);
      pushLiveUi();
    }
  }

  function scheduleWsReconnect() {
    if (wsReconnectTimer) {
      clearTimeout(wsReconnectTimer);
      wsReconnectTimer = null;
    }
    wsFailedAttempts += 1;
    if (wsFailedAttempts > WS_MAX_ATTEMPTS) {
      // The /ws push channel is optional (signal_warning / live_message are
      // also HTTP-polled). Stop retrying until the next page load rather than
      // hammering a broken endpoint forever.
      return;
    }
    var delay = Math.min(wsBackoffMs, WS_MAX_BACKOFF_MS);
    wsBackoffMs = Math.min(wsBackoffMs * 2, WS_MAX_BACKOFF_MS);
    delay += Math.floor(Math.random() * 1000); // jitter
    wsReconnectTimer = setTimeout(openWs, delay);
  }

  function openWs() {
    if (wsReconnectTimer) {
      clearTimeout(wsReconnectTimer);
      wsReconnectTimer = null;
    }
    var opened = false;
    try {
      var proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      var ws = new WebSocket(proto + '//' + window.location.host + '/ws?surface=space');
      ws.onopen = function () {
        opened = true;
        wsBackoffMs = WS_RECONNECT_MS;
        wsFailedAttempts = 0;
      };
      ws.onmessage = function (event) {
        try {
          handleWsMessage(JSON.parse(event.data));
        } catch (_) {}
      };
      ws.onclose = function () {
        if (opened) {
          // A live connection dropped — retry promptly at the base interval.
          wsBackoffMs = WS_RECONNECT_MS;
          wsFailedAttempts = 0;
        }
        scheduleWsReconnect();
      };
      ws.onerror = function () {};
    } catch (_) {
      scheduleWsReconnect();
    }
  }

  function connectWs() {
    wsBackoffMs = WS_RECONNECT_MS;
    wsFailedAttempts = 0;
    if (wsReconnectTimer) clearTimeout(wsReconnectTimer);
    wsReconnectTimer = setTimeout(openWs, WS_INITIAL_DELAY_MS);
  }

  function init() {
    wireChannelOverlayMeasure();
    renderDefaultIdentifierStrip();
    fetchSignals();
    fetchEmergency();
    fetchOrgLive();
    connectWs();
    setInterval(fetchSignals, SIGNAL_REFRESH_MS);
    setInterval(fetchEmergency, EMERGENCY_REFRESH_MS);
    setInterval(fetchOrgLive, ORG_LIVE_REFRESH_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.GriGsiSpaceServerChannel = {
    getOrgLiveData: function () {
      return lastOrgLiveRaw;
    },
    refreshOrgLive: fetchOrgLive,
  };
})();

;
"use strict";

/** Signed cap guest delegate permissions (invite / viewer / access settings). */
(function (global) {
  const CAP_GUEST_PERM_KEYS = ["invite", "viewer", "settings"];
  const PERM_LABELS = {
    invite: "Invite others",
    viewer: "Add viewer",
    settings: "Access settings",
  };

  function normalizeCapPerms(input) {
    const raw = Array.isArray(input) ? input : [];
    const set = new Set();
    raw.forEach((p) => {
      const k = String(p || "").toLowerCase().trim();
      if (CAP_GUEST_PERM_KEYS.includes(k)) set.add(k);
    });
    return CAP_GUEST_PERM_KEYS.filter((k) => set.has(k));
  }

  function capPermsFromPayload(payload) {
    if (!payload || typeof payload !== "object") return [];
    return normalizeCapPerms(payload.perms);
  }

  function capAllowsPerm(payload, perm) {
    const key = String(perm || "").toLowerCase().trim();
    if (!CAP_GUEST_PERM_KEYS.includes(key)) return false;
    return capPermsFromPayload(payload).includes(key);
  }

  function permKeyFromCheckbox(el) {
    return String(
      el.getAttribute("data-invite-perm") ||
        el.getAttribute("data-share-guest-perm") ||
        el.getAttribute("data-access-guest-perm") ||
        ""
    ).toLowerCase();
  }

  function isPermToggleButton(el) {
    return !!(
      el &&
      el.matches &&
      el.matches(
        "button[data-invite-perm], button[data-share-guest-perm], button[data-access-guest-perm], button[data-guest-perm-all]"
      )
    );
  }

  function isPermChecked(el) {
    if (!el) return false;
    if (el.type === "checkbox") return !!el.checked;
    if (isPermToggleButton(el)) return el.classList.contains("is-on");
    return false;
  }

  function setPermChecked(el, on) {
    if (!el) return;
    if (el.type === "checkbox") {
      el.checked = !!on;
      return;
    }
    if (isPermToggleButton(el)) {
      el.classList.toggle("is-on", !!on);
      el.setAttribute("aria-pressed", on ? "true" : "false");
    }
  }

  function itemCheckboxesInGroup(root) {
    if (!root) return [];
    return Array.from(
      root.querySelectorAll("[data-invite-perm], [data-share-guest-perm], [data-access-guest-perm]")
    );
  }

  function syncAllCheckboxInGroup(root) {
    const allEl = root && root.querySelector("[data-guest-perm-all]");
    const items = itemCheckboxesInGroup(root);
    if (!allEl || !items.length) return;
    const every = items.every((el) => isPermChecked(el));
    const some = items.some((el) => isPermChecked(el));
    if (allEl.type === "checkbox") {
      allEl.checked = every;
      allEl.indeterminate = some && !every;
    } else if (isPermToggleButton(allEl)) {
      setPermChecked(allEl, every);
    }
  }

  function applyPermsToGroup(root, perms) {
    if (!root) return;
    const set = new Set(normalizeCapPerms(perms));
    itemCheckboxesInGroup(root).forEach((el) => {
      const key = permKeyFromCheckbox(el);
      if (key) setPermChecked(el, set.has(key));
    });
    syncAllCheckboxInGroup(root);
  }

  function wireGuestPermGroup(root) {
    if (!root || root.dataset.guestPermWired === "1") return;
    root.dataset.guestPermWired = "1";
    const allEl = root.querySelector("[data-guest-perm-all]");
    const items = itemCheckboxesInGroup(root);
    if (!allEl || !items.length) return;

    const notify = () => {
      try {
        root.dispatchEvent(new CustomEvent("grigsi-guest-perms-change", { bubbles: true }));
      } catch (_) {}
    };

    const onAllToggle = () => {
      let turnOn = false;
      if (allEl.type === "checkbox") {
        turnOn = !!allEl.checked;
        allEl.indeterminate = false;
      } else {
        turnOn = !items.every((el) => isPermChecked(el));
      }
      items.forEach((el) => setPermChecked(el, turnOn));
      syncAllCheckboxInGroup(root);
      notify();
    };

    if (allEl.type === "checkbox") {
      allEl.addEventListener("change", onAllToggle);
    } else if (isPermToggleButton(allEl)) {
      allEl.addEventListener("click", (e) => {
        e.preventDefault();
        onAllToggle();
      });
    }

    items.forEach((el) => {
      if (el.type === "checkbox") {
        el.addEventListener("change", () => {
          syncAllCheckboxInGroup(root);
          notify();
        });
        return;
      }
      if (isPermToggleButton(el)) {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          setPermChecked(el, !isPermChecked(el));
          syncAllCheckboxInGroup(root);
          notify();
        });
      }
    });
    syncAllCheckboxInGroup(root);
  }

  function wireAllGuestPermGroups() {
    document.querySelectorAll("[data-guest-perm-group]").forEach((root) => wireGuestPermGroup(root));
  }

  function readCheckedPerms(selector) {
    const picked = [];
    document.querySelectorAll(selector).forEach((el) => {
      if (!el || el.hasAttribute("data-guest-perm-all")) return;
      if (!isPermChecked(el)) return;
      const key = permKeyFromCheckbox(el);
      if (key) picked.push(key);
    });
    return normalizeCapPerms(picked);
  }

  function summarizeGuestPerms(perms) {
    const p = normalizeCapPerms(perms);
    if (!p.length) return "Guest: chat and files only (cannot invite, add viewers, or change settings)";
    if (p.length === CAP_GUEST_PERM_KEYS.length) return "Guest: all delegate options";
    return "Guest may also: " + p.map((k) => PERM_LABELS[k] || k).join(", ");
  }

  function inviteLinkHasCap(linkUrl) {
    return /[?&]cap=/i.test(String(linkUrl || ""));
  }

  /** Hint + whether Copy code should use the signed invite link (not plain code). */
  function buildInviteAccessHint(opts) {
    const o = opts && typeof opts === "object" ? opts : {};
    const capLink = inviteLinkHasCap(o.linkUrl);
    const trusted = !!o.trustedMode || (!capLink && !o.usesCapMode);
    if (trusted) {
      return {
        kind: "standard",
        text:
          "Typing the code alone gives standard guest access. Use invite link or QR with options checked below for more.",
        copyInviteLink: false,
      };
    }
    const permLine = summarizeGuestPerms(o.perms);
    if (!capLink) {
      return {
        kind: "pending",
        text: permLine + " Generating invite with limits…",
        copyInviteLink: false,
      };
    }
    return {
      kind: normalizeCapPerms(o.perms).length ? "limited" : "cap_only",
      text:
        permLine +
        " QR and link include limits. Copy code pastes the invite — paste it in Join.",
      copyInviteLink: true,
    };
  }

  function inviteCopyTextForShare(opts) {
    const o = opts && typeof opts === "object" ? opts : {};
    const hint = buildInviteAccessHint(o);
    if (hint.copyInviteLink && o.linkUrl) return String(o.linkUrl);
    return String(o.displayCode || "").trim();
  }

  global.GriGsiCapGuestPerms = {
    CAP_GUEST_PERM_KEYS,
    PERM_LABELS,
    normalizeCapPerms,
    capPermsFromPayload,
    capAllowsPerm,
    summarizeGuestPerms,
    inviteLinkHasCap,
    buildInviteAccessHint,
    inviteCopyTextForShare,
    readCheckedPerms,
    wireGuestPermGroup,
    wireAllGuestPermGroups,
    applyPermsToGroup,
    syncAllCheckboxInGroup,
  };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/**
 * Connection / access modes — one vocabulary for UI, JS, and HTML data-* attributes.
 *
 * | ID (canonical) | UI title     | UI subtitle        | Signed cap kind (legacy) |
 * |----------------|--------------|--------------------|--------------------------|
 * | one_time       | One-time     | Until session ends | temporary                |
 * | action         | 10 Actions   | 10 actions         | action                   |
 * | fixed_term     | Fixed-term   | 30 days            | business                 |
 * | trusted        | Trusted      | No limit           | trusted                  |
 *
 * Cap payloads keep legacy kind strings so existing invite links stay valid.
 */
(function (global) {
  const IDS = Object.freeze({
    ONE_TIME: "one_time",
    ACTION: "action",
    FIXED_TERM: "fixed_term",
    TRUSTED: "trusted",
  });

  const ALL_IDS = Object.freeze([
    IDS.ONE_TIME,
    IDS.ACTION,
    IDS.FIXED_TERM,
    IDS.TRUSTED,
  ]);

  /** Legacy strings embedded in signed cap tokens — do not rename in new signatures. */
  const CAP_KIND_BY_MODE = Object.freeze({
    one_time: "temporary",
    action: "action",
    fixed_term: "business",
    trusted: "trusted",
  });

  const MODE_BY_CAP_KIND = Object.freeze({
    temporary: IDS.ONE_TIME,
    action: IDS.ACTION,
    business: IDS.FIXED_TERM,
    trusted: IDS.TRUSTED,
  });

  const ALIAS = Object.freeze({
    temporary: IDS.ONE_TIME,
    one_time: IDS.ONE_TIME,
    "one-time": IDS.ONE_TIME,
    onetime: IDS.ONE_TIME,
    action: IDS.ACTION,
    business: IDS.FIXED_TERM,
    fixed_term: IDS.FIXED_TERM,
    "fixed-term": IDS.FIXED_TERM,
    fixedterm: IDS.FIXED_TERM,
    trusted: IDS.TRUSTED,
  });

  function normalize(input, fallback) {
    let fb = IDS.TRUSTED;
    if (fallback !== undefined && fallback !== null && fallback !== "") {
      const fk = String(fallback)
        .toLowerCase()
        .trim()
        .replace(/-/g, "_");
      fb = ALIAS[fk] || IDS.TRUSTED;
    }
    const raw = String(input || "")
      .toLowerCase()
      .trim()
      .replace(/-/g, "_");
    return ALIAS[raw] || fb;
  }

  function is(a, b) {
    return normalize(a) === normalize(b);
  }

  function usesCapInviteLink(mode) {
    return !is(mode, IDS.TRUSTED);
  }

  function capKind(mode) {
    const id = normalize(mode, IDS.ONE_TIME);
    return CAP_KIND_BY_MODE[id] || CAP_KIND_BY_MODE[IDS.ONE_TIME];
  }

  function fromCapKind(kind) {
    const k = String(kind || "").toLowerCase().trim();
    return MODE_BY_CAP_KIND[k] || normalize(k);
  }

  function storageKind(mode) {
    return normalize(mode);
  }

  function fromStorageKind(kind) {
    return normalize(kind);
  }

  function matchesStorageKind(storedKind, filterMode) {
    return is(storedKind, filterMode);
  }

  function isKnown(input) {
    const raw = String(input || "")
      .toLowerCase()
      .trim()
      .replace(/-/g, "_");
    return !!ALIAS[raw];
  }

  global.GriGsiAccessModes = {
    IDS,
    ALL_IDS,
    CAP_KIND_BY_MODE,
    MODE_BY_CAP_KIND,
    normalize,
    is,
    isKnown,
    usesCapInviteLink,
    capKind,
    fromCapKind,
    storageKind,
    fromStorageKind,
    matchesStorageKind,
  };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Access policy labels and invite-link helpers (Space shell). */
(function (global) {
  const AX = () => global.GriGsiAccessModes;
  const axLegacyMode = Object.freeze({ temporary: "one_time", business: "fixed_term" });

  function ax(v, fb) {
    if (AX()) return AX().normalize(v, fb);
    const raw = String(v || fb || "trusted")
      .toLowerCase()
      .replace(/-/g, "_");
    return axLegacyMode[raw] || raw;
  }

  function axIs(a, b) {
    return AX() ? AX().is(a, b) : ax(a) === ax(b);
  }

  function withShareModule(url, moduleName) {
    if (!url || !moduleName) return url || "";
    try {
      const u = new URL(url, global.location.origin);
      u.searchParams.set("module", moduleName);
      return u.toString();
    } catch (_) {
      return url;
    }
  }

  function moduleForAccessAction(action) {
    if (action === "file") return "files";
    if (action === "video") return "video";
    if (action === "screen") return "screen";
    return "chat";
  }

  function scopeForAccessAction(action) {
    if (action === "bundle" || action === "all") return "action:bundle_10";
    if (action === "file") return "action:send_file";
    if (action === "screen") return "action:share_screen";
    if (action === "video") return "action:video_once";
    return "action:join_once";
  }

  function actionFromScope(scope, href) {
    const s = String(scope || "").toLowerCase();
    if (s === "action:bundle_10") return "bundle";
    if (s === "action:send_file") return "file";
    if (s === "action:share_screen") return "screen";
    if (s === "action:video_once") return "video";
    try {
      const mod = new URL(href || global.location.href, global.location.origin).searchParams.get("module");
      if (mod === "video") return "video";
      if (mod === "files") return "file";
      if (mod === "screen") return "screen";
    } catch (_) {}
    return "chat";
  }

  function formatAccessExpiry(exp) {
    const ts = Number(exp) || 0;
    if (!ts) return "";
    const diff = ts - Date.now();
    if (diff <= 0) return "expired";
    const h = Math.round(diff / (60 * 60 * 1000));
    if (h < 48) return h + "h left";
    const d = Math.round(diff / (24 * 60 * 60 * 1000));
    return d + "d left";
  }

  function accessSummary(policy) {
    const p = policy || {};
    const mode = ax(p.mode, "trusted");
    if (axIs(mode, "action")) {
      const AL = global.GriGsiSpaceActionLimits;
      const actionTitle =
        (global.GriGsiConnectModeLabels && global.GriGsiConnectModeLabels.ACTION_MODE_TITLE) || "10 Actions";
      if (AL && AL.isBundleAction(p)) {
        return actionTitle + " · 10 each (chat, files, video, screen)";
      }
      const act =
        p.action === "file" ? "file" : p.action === "video" ? "video" : p.action === "screen" ? "screen" : "chat";
      if (act === "chat" && AL) {
        return actionTitle + " · chat (" + AL.CHAT_MAX + " messages)";
      }
      if (act === "file" && AL) return actionTitle + " · files (" + AL.FILE_MAX + " shares)";
      if ((act === "video" || act === "screen") && AL) return actionTitle + " · " + act + " (once)";
      return actionTitle + " · " + act + " once";
    }
    if (axIs(mode, "one_time")) {
      const L = global.GriGsiConnectModeLabels;
      return L && L.ONE_TIME_SUMMARY ? L.ONE_TIME_SUMMARY : "One-time · until session ends";
    }
    if (axIs(mode, "fixed_term")) {
      const L = global.GriGsiConnectModeLabels;
      const title = L && L.FIXED_TERM_MODE_TITLE ? L.FIXED_TERM_MODE_TITLE : "Fixed-term";
      const exp = formatAccessExpiry(p.expires_at);
      return exp ? title + " · " + exp : title + " · until date set";
    }
    return "Trusted · no limit";
  }

  function normalizeInviteAction(actionRaw, fallback) {
    const fb = fallback === undefined ? "bundle" : fallback;
    const a = String(actionRaw || "chat").toLowerCase();
    if (a === "bundle" || a === "all") return "bundle";
    if (a === "file" || a === "video" || a === "screen" || a === "chat") return a;
    return fb;
  }

  function guestPermsFromSettings(settings) {
    const GP = global.GriGsiCapGuestPerms;
    return GP && GP.normalizeCapPerms ? GP.normalizeCapPerms(settings && settings.guest_perms) : [];
  }

  function capPermsFromPayload(payload) {
    const GP = global.GriGsiCapGuestPerms;
    return GP && GP.capPermsFromPayload ? GP.capPermsFromPayload(payload) : [];
  }

  function basePolicyFields(guestPerms, expires_at, cap_jti, source, link) {
    const perms = guestPerms || [];
    return {
      cap_perms: perms,
      guest_perms: perms,
      expires_at: Number(expires_at) || null,
      cap_jti: String(cap_jti || ""),
      source: source || "",
      link: link || "",
    };
  }

  function buildPolicyFromInviteCanon(canon, actionRaw, fields) {
    const meta = basePolicyFields(
      fields.guest_perms,
      fields.expires_at,
      fields.cap_jti,
      fields.source,
      fields.link
    );
    if (axIs(canon, "action")) {
      return { mode: "action", action: normalizeInviteAction(actionRaw), ...meta };
    }
    if (axIs(canon, "one_time")) {
      return { mode: "one_time", action: normalizeInviteAction(actionRaw), ...meta };
    }
    if (axIs(canon, "fixed_term")) {
      const act = normalizeInviteAction(actionRaw, "chat");
      return { mode: "fixed_term", action: act === "bundle" ? "bundle" : "chat", ...meta };
    }
    return {
      mode: "trusted",
      action: "chat",
      cap_perms: [],
      guest_perms: [],
      expires_at: meta.expires_at,
      cap_jti: meta.cap_jti,
      source: meta.source,
      link: meta.link,
    };
  }

  function buildPolicyFromCapKind(kind, payload, href) {
    const capPerms = capPermsFromPayload(payload);
    const meta = {
      cap_perms: capPerms,
      guest_perms: capPerms,
      expires_at: Number(payload.exp) || null,
      cap_jti: String(payload.jti || ""),
      source: "url_cap",
      link: href || global.location.href,
    };
    const k = String(kind || "").toLowerCase();
    if (k === "action") {
      return { mode: "action", action: actionFromScope(payload.scope, href), ...meta };
    }
    if (k === "temporary") return { mode: "temporary", action: "chat", ...meta };
    if (k === "business") return { mode: "business", action: "chat", ...meta };
    return { mode: "trusted", action: "chat", ...meta };
  }

  function businessExpiresFromInput(inputEl) {
    if (!inputEl || !inputEl.value) return null;
    const until = new Date(inputEl.value + "T23:59:59").getTime();
    return Number.isFinite(until) && until > Date.now() ? until : null;
  }

  function buildPolicyFromRelationMode(mode, action, basePolicy, businessInput) {
    const base = { ...(basePolicy || {}), source: "host_session" };
    const m = String(mode || "").toLowerCase();
    if (m === "action") {
      return {
        ...base,
        mode: "action",
        action: normalizeInviteAction(action),
        expires_at: base.expires_at || null,
      };
    }
    if (m === "temporary") {
      return { ...base, mode: "temporary", action: "chat", expires_at: null, cap_jti: "" };
    }
    if (m === "business") {
      return {
        ...base,
        mode: "business",
        action: "chat",
        expires_at: businessExpiresFromInput(businessInput),
        cap_jti: "",
      };
    }
    return { ...base, mode: "trusted", action: "chat", expires_at: null, cap_jti: "" };
  }

  function capErrorMessage(err) {
    const e = String(err || "");
    if (e === "expired" || e === "consumed") return "This invite can no longer be used.";
    if (e === "wrong_space") return "This link is for another Space.";
    if (e === "unsigned_cap") return "Outdated link — create a new one from Connect.";
    if (e === "invalid_signature") return "This link could not be verified.";
    if (e === "relay_failed") return "Could not confirm link with server.";
    return "This link is not valid.";
  }

  function urlHasCapParam(href) {
    try {
      return !!new URL(href || global.location.href, global.location.origin).searchParams.get("cap");
    } catch (_) {
      return false;
    }
  }

  global.GriGsiSpaceAccessUtils = {
    withShareModule,
    moduleForAccessAction,
    scopeForAccessAction,
    actionFromScope,
    formatAccessExpiry,
    accessSummary,
    ax,
    axIs,
    normalizeInviteAction,
    guestPermsFromSettings,
    capPermsFromPayload,
    buildPolicyFromInviteCanon,
    buildPolicyFromCapKind,
    buildPolicyFromRelationMode,
    businessExpiresFromInput,
    capErrorMessage,
    urlHasCapParam,
  };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Create Space wizard — relation step + quick pick (?pick=1). */
(function (global) {
  let ctx = null;
  let onCreateWizardPick = null;

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function setWizardBootPhase(phase) {
    const html = document.documentElement;
    const quickPick = c().quickPickRequested;
    if (!quickPick || !quickPick()) {
      html.classList.remove("grigsi-wizard-pending", "grigsi-wizard-pending--relation", "grigsi-wizard-pending--pick");
      return;
    }
    html.classList.add("grigsi-wizard-pending");
    html.classList.remove("grigsi-wizard-pending--relation", "grigsi-wizard-pending--pick");
    if (phase === "relation") html.classList.add("grigsi-wizard-pending--relation");
    else if (phase === "pick") html.classList.add("grigsi-wizard-pending--pick");
  }

  function hide() {
    const root = document.getElementById("space-quick-pick");
    if (!root) return;
    root.classList.add("hidden");
    root.setAttribute("hidden", "");
    const relRoot = document.getElementById("space-relationship-step");
    if (relRoot) {
      relRoot.classList.add("hidden");
      relRoot.setAttribute("hidden", "");
    }
    document.body.classList.remove("grigsi-wizard-open");
    document.documentElement.classList.remove(
      "grigsi-wizard-pending",
      "grigsi-wizard-pending--relation",
      "grigsi-wizard-pending--pick"
    );
    try {
      if (typeof c().syncChatEmptyQuickActions === "function") c().syncChatEmptyQuickActions();
    } catch (_) {}
  }

  function showQuickPick() {
    const x = c();
    const moduleParam = x.getModuleParam ? x.getModuleParam() : "";
    if (moduleParam || (x.passwordGateIsOpen && x.passwordGateIsOpen()) || !(x.quickPickRequested && x.quickPickRequested())) {
      return false;
    }
    if (x.skipCreateQuickPickForHeroUi && x.skipCreateQuickPickForHeroUi()) return false;
    const secret = x.getSpaceSecret ? x.getSpaceSecret() : "";
    if (!(x.isRelationStepDone && x.isRelationStepDone(secret))) return false;
    const relRoot = document.getElementById("space-relationship-step");
    if (relRoot) {
      relRoot.classList.add("hidden");
      relRoot.setAttribute("hidden", "");
    }
    const root = document.getElementById("space-quick-pick");
    if (!root) return false;
    const codeEl = document.getElementById("space-quick-pick-code");
    const disp = x.displaySpaceSecret;
    if (codeEl) codeEl.textContent = secret && disp ? disp(secret) : secret || "";
    root.classList.remove("hidden");
    root.removeAttribute("hidden");
    document.body.classList.add("grigsi-wizard-open");
    setWizardBootPhase("pick");
    return true;
  }

  function wireButtons() {
    const x = c();
    const quickPickRoot = document.getElementById("space-quick-pick");
    if (quickPickRoot && quickPickRoot.dataset.pickWired !== "1") {
      quickPickRoot.dataset.pickWired = "1";
      if (x.videoRemoved) {
        quickPickRoot.querySelectorAll('[data-space-pick="video"], [data-space-pick="screen"]').forEach((el) => {
          el.classList.add("hidden");
          el.setAttribute("hidden", "");
          el.disabled = true;
        });
      }
      quickPickRoot.querySelectorAll("[data-space-pick]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const mod = String(btn.getAttribute("data-space-pick") || "").toLowerCase();
          if (!mod) return;
          if (typeof onCreateWizardPick === "function") {
            onCreateWizardPick(mod);
            return;
          }
          if (typeof global.__grigsiActivateSpaceModule === "function") {
            global.__grigsiActivateSpaceModule(mod, { direct: true, fromQuickPick: true });
            return;
          }
          try {
            global.__grigsiPendingQuickPick = mod;
          } catch (_) {}
        });
      });
    }

    const relRoot = document.getElementById("space-relationship-step");
    if (!relRoot || relRoot.dataset.relWired === "1") return;
    relRoot.dataset.relWired = "1";
    const modeButtons = Array.from(relRoot.querySelectorAll("[data-rel-mode]"));
    const relPanels = Array.from(relRoot.querySelectorAll("[data-rel-panel]"));
    const DEFAULT_TEMP_HOURS = 24;
    const DEFAULT_BUSINESS_DAYS = 30;
    let mode = "one_time";

    function setMode(next) {
      const AXm = global.GriGsiAccessModes;
      mode = AXm ? AXm.normalize(next, AXm.IDS.ONE_TIME) : String(next || "one_time");
      modeButtons.forEach((btn) => {
        const on = AXm
          ? AXm.is(btn.getAttribute("data-rel-mode"), mode)
          : btn.getAttribute("data-rel-mode") === mode;
        btn.classList.toggle("is-on", on);
        btn.setAttribute("aria-checked", on ? "true" : "false");
      });
      relPanels.forEach((panel) => {
        const show = AXm
          ? AXm.is(panel.getAttribute("data-rel-panel"), mode)
          : panel.getAttribute("data-rel-panel") === mode;
        panel.classList.toggle("hidden", !show);
        if (show) panel.removeAttribute("hidden");
        else panel.setAttribute("hidden", "");
      });
    }

    function initDefaultDateInputs() {
      const now = new Date();
      const tempUntil = new Date(now.getTime() + DEFAULT_TEMP_HOURS * 60 * 60 * 1000);
      const tempInput = document.getElementById("space-rel-temp-until");
      if (tempInput && !tempInput.value) {
        const localIso = new Date(tempUntil.getTime() - tempUntil.getTimezoneOffset() * 60000)
          .toISOString()
          .slice(0, 16);
        tempInput.value = localIso;
      }
      const businessUntil = new Date(now.getTime() + DEFAULT_BUSINESS_DAYS * 24 * 60 * 60 * 1000);
      const bizInput = document.getElementById("space-rel-business-until");
      if (bizInput && !bizInput.value) {
        const yyyy = businessUntil.getFullYear();
        const mm = String(businessUntil.getMonth() + 1).padStart(2, "0");
        const dd = String(businessUntil.getDate()).padStart(2, "0");
        bizInput.value = yyyy + "-" + mm + "-" + dd;
      }
    }

    initDefaultDateInputs();
    if (global.GriGsiConnectModeLabels) {
      global.GriGsiConnectModeLabels.syncTempFromPair("space-rel-temp-hours", "space-rel-temp-until");
      global.GriGsiConnectModeLabels.syncBusinessFromDateInput("space-rel-business-until");
    }
    setMode("one_time");

    function advanceFromRelationStep() {
      if (relRoot.classList.contains("hidden") || relRoot.hidden) return;
      const secret = x.getSpaceSecret ? x.getSpaceSecret() : "";
      if (x.storeRelationChoice) x.storeRelationChoice(secret, mode, "chat");
      if (x.markRelationStepDone) x.markRelationStepDone(secret);
      if (x.hydrateAccessPolicyFromRelationSession) x.hydrateAccessPolicyFromRelationSession();
      if (x.ensureCapInviteLinkForHostPolicy) void x.ensureCapInviteLinkForHostPolicy();
      relRoot.classList.add("hidden");
      relRoot.setAttribute("hidden", "");
      if (x.skipCreateQuickPickForHeroUi && x.skipCreateQuickPickForHeroUi()) return;
      showQuickPick();
    }

    global.__grigsiAdvanceRelationStep = advanceFromRelationStep;
    modeButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        setMode(btn.getAttribute("data-rel-mode") || "one_time");
        advanceFromRelationStep();
      });
    });
  }

  function boot() {
    wireButtons();
    const x = c();
    const moduleParam = x.getModuleParam ? x.getModuleParam() : "";
    if (!(x.quickPickRequested && x.quickPickRequested()) || moduleParam) return;
    const secret = x.getSpaceSecret ? x.getSpaceSecret() : "";
    if (x.hasPrecreateInviteFromInstant && x.hasPrecreateInviteFromInstant(secret) && x.markRelationStepDone) {
      x.markRelationStepDone(secret);
    }
    if (x.passwordGateIsOpen && x.passwordGateIsOpen()) return;

    const relRoot = document.getElementById("space-relationship-step");
    const quickPickRoot = document.getElementById("space-quick-pick");

    if (
      !(x.isRelationStepDone && x.isRelationStepDone(secret)) &&
      !(x.hasPrecreateInviteFromInstant && x.hasPrecreateInviteFromInstant(secret)) &&
      relRoot
    ) {
      if (quickPickRoot) {
        quickPickRoot.classList.add("hidden");
        quickPickRoot.setAttribute("hidden", "");
      }
      relRoot.classList.remove("hidden");
      relRoot.removeAttribute("hidden");
      document.body.classList.add("grigsi-wizard-open");
      setWizardBootPhase("relation");
      return;
    }
    showQuickPick();
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    boot();
  }

  function setOnPick(handler) {
    onCreateWizardPick = typeof handler === "function" ? handler : null;
  }

  function maybeShowQuickPick() {
    const x = c();
    const moduleParam = x.getModuleParam ? x.getModuleParam() : "";
    if (moduleParam || (x.passwordGateIsOpen && x.passwordGateIsOpen()) || !(x.quickPickRequested && x.quickPickRequested())) {
      return;
    }
    if (x.skipCreateQuickPickForHeroUi && x.skipCreateQuickPickForHeroUi()) return;
    if (x.clearQuickPickPending) x.clearQuickPickPending();
    showQuickPick();
  }

  global.GriGsiSpaceWizard = {
    init,
    boot,
    wireButtons,
    showQuickPick,
    hide,
    setOnPick,
    maybeShowQuickPick,
    setWizardBootPhase,
  };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Access limit exhausted — modal, banner, expiry watch, event bridge. */
(function (global) {
  let ctx = null;
  let shownKey = "";
  let pollTimer = 0;
  let modalWired = false;

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function policy() {
    const g = c().getPolicy;
    return g && typeof g === "function" ? g() || {} : {};
  }

  function isTimeExpired(p) {
    const pol = p || policy();
    const exp = Number(pol.expires_at) || 0;
    if (!exp) return false;
    return Date.now() >= exp;
  }

  function shouldWatchExpiry(p) {
    const pol = p || policy();
    const mode = String(pol.mode || "").toLowerCase();
    return (mode === "temporary" || mode === "business") && (Number(pol.expires_at) || 0) > 0;
  }

  function limitExhaustedCopy(reason, detail) {
    const r = String(reason || "expired");
    const p = policy();
    const AL = global.GriGsiSpaceActionLimits;
    if (AL && (r === "action_limit" || r === "action_exhausted" || r === "action_used" || r === "action_chat_limit")) {
      return AL.messageForExhausted(p, detail || { scope: AL.scopeForPolicy(p) });
    }
    if (r === "temporary_expired" || (r === "expired" && p.mode === "temporary")) {
      return "This invite can no longer be used.";
    }
    if (r === "business_expired" || (r === "expired" && p.mode === "business")) {
      return "Fixed-term access for this Space has ended.";
    }
    if (r === "consumed") return "This invite can no longer be used.";
    if (r === "revoked") return "The current access link was revoked.";
    if (detail && detail.message) return String(detail.message);
    return "Access for this Space has reached its limit.";
  }

  function configureModal() {
    const settingsBtn = document.getElementById("space-limit-exhausted-settings");
    const endBtn = document.getElementById("space-limit-exhausted-end");
    const guestPerm = c().guestHasDelegatePerm;
    if (endBtn) endBtn.textContent = "End communication";
    if (settingsBtn && typeof guestPerm === "function") {
      settingsBtn.classList.toggle("hidden", !guestPerm("settings"));
    }
  }

  function updateSignaling(message, showBanner) {
    const chip = c().getAccessChipEl && c().getAccessChipEl();
    const render = c().renderAccessChip;
    const banner = document.getElementById("space-limit-exhausted-banner");
    const bannerText = document.getElementById("space-limit-exhausted-banner-text");
    if (chip) {
      chip.classList.toggle("is-limit-exhausted", !!showBanner);
      if (showBanner) chip.title = "Limit reached — open Access settings";
      else if (typeof render === "function") render();
    }
    if (banner && bannerText) {
      bannerText.textContent = message || "Access limit reached for this Space.";
      banner.classList.toggle("hidden", !showBanner);
    }
    try {
      document.body.classList.toggle("space-limit-exhausted", !!showBanner);
    } catch (_) {}
  }

  function closeModal() {
    const modal = document.getElementById("space-limit-exhausted-modal");
    if (modal) modal.classList.remove("active");
  }

  function openModal(message) {
    const modal = document.getElementById("space-limit-exhausted-modal");
    const messageEl = document.getElementById("space-limit-exhausted-message");
    if (!modal) return;
    configureModal();
    if (messageEl) messageEl.textContent = message || limitExhaustedCopy("expired");
    modal.classList.add("active");
    try {
      document.getElementById("space-limit-exhausted-end")?.focus();
    } catch (_) {}
  }

  function signal(detail) {
    const pol = policy();
    const reason = (detail && detail.reason) || "expired";
    const key = reason + ":" + String((detail && detail.scope) || "") + ":" + String(pol.mode || "");
    if (shownKey === key) return;
    shownKey = key;
    const msg = limitExhaustedCopy(reason, detail);
    updateSignaling(msg, true);
    openModal(msg);
    const toast = c().showToast;
    if (typeof toast === "function") toast(msg, "warning");
    void (async () => {
      const secretFn = c().getSpaceSecret;
      const secret = secretFn && typeof secretFn === "function" ? secretFn() : "";
      const SB = global.GriGsiSpaceBook || global.GriGsiConnectLocalMode;
      if (!SB || !SB.markSpacebookEntryExpired || !secret) return;
      try {
        await SB.markSpacebookEntryExpired(secret);
        const refresh = c().refreshSpacebookLists;
        if (typeof refresh === "function") refresh();
      } catch (_) {}
    })();
  }

  function clear() {
    shownKey = "";
    closeModal();
    updateSignaling("", false);
    const AL = global.GriGsiSpaceActionLimits;
    if (!AL || !AL.isActionMode || !AL.resetQuota) return;
    const pol = policy();
    if (!AL.isActionMode(pol)) return;
    const secretFn = c().getSpaceSecret;
    const capFn = c().getCachedCapPayload;
    const secret = secretFn && typeof secretFn === "function" ? secretFn() : "";
    const cap = capFn && typeof capFn === "function" ? capFn() : null;
    AL.resetQuota(pol, secret, cap);
  }

  function checkTimeLimit() {
    const pol = policy();
    if (!shouldWatchExpiry(pol)) return;
    if (!isTimeExpired(pol)) return;
    const mode = String(pol.mode || "").toLowerCase();
    signal({ reason: mode === "business" ? "business_expired" : "temporary_expired" });
  }

  function startExpiryWatch() {
    if (pollTimer) clearInterval(pollTimer);
    if (!shouldWatchExpiry(policy())) return;
    checkTimeLimit();
    pollTimer = global.setInterval(() => checkTimeLimit(), 15000);
  }

  function wireEventBridge() {
    global.addEventListener("grigsi-space-limit-exhausted", (ev) => {
      const d = ev && ev.detail;
      if (d) signal(d);
    });
  }

  function wireModalActions(handlers) {
    if (modalWired) return;
    const endBtn = document.getElementById("space-limit-exhausted-end");
    const settingsBtn = document.getElementById("space-limit-exhausted-settings");
    const modal = document.getElementById("space-limit-exhausted-modal");
    if (!endBtn && !settingsBtn && !modal) return;
    modalWired = true;
    const h = handlers && typeof handlers === "object" ? handlers : {};
    endBtn?.addEventListener("click", () => {
      closeModal();
      if (typeof h.onEnd === "function") h.onEnd();
    });
    settingsBtn?.addEventListener("click", () => {
      closeModal();
      if (typeof h.onSettings === "function") h.onSettings();
    });
    modal?.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    wireEventBridge();
    global.GriGsiSpaceLimit = {
      signal,
      clear,
      isTimeExpired,
    };
    return global.GriGsiSpaceLimit;
  }

  global.GriGsiSpaceLimitUi = {
    init,
    wireModalActions,
    signal,
    clear,
    closeModal,
    isTimeExpired,
    shouldWatchExpiry,
    checkTimeLimit,
    startExpiryWatch,
    limitExhaustedCopy,
  };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Cap delegate perms + host dock visibility (Space shell). */
(function (global) {
  let ctx = null;

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function policy() {
    const g = c().getPolicy;
    return g && typeof g === "function" ? g() || {} : {};
  }

  function urlHasCap(href) {
    const AU = global.GriGsiSpaceAccessUtils;
    if (AU && AU.urlHasCapParam) return AU.urlHasCapParam(href);
    try {
      return !!new URL(href || global.location.href, global.location.origin).searchParams.get("cap");
    } catch (_) {
      return false;
    }
  }

  function resolveCapDelegatePayload() {
    const getCap = c().getCachedCapPayload;
    const setCap = c().setCachedCapPayload;
    let cap = getCap && typeof getCap === "function" ? getCap() : null;
    if (cap) return cap;
    const secretFn = c().getSpaceSecret;
    const secret = secretFn && typeof secretFn === "function" ? secretFn() : "";
    const SB = global.GriGsiSpaceBook || global.GriGsiConnectLocalMode;
    if (SB && SB.loadStashedCapDelegatePayload) {
      const stashed = SB.loadStashedCapDelegatePayload(secret);
      if (stashed && stashed.jti) {
        if (setCap) setCap(stashed);
        return stashed;
      }
    }
    return null;
  }

  function capPermsFromPolicyOrPayload() {
    const GP = global.GriGsiCapGuestPerms;
    if (!GP) return [];
    const payload = resolveCapDelegatePayload();
    if (payload) return GP.capPermsFromPayload(payload);
    if (!urlHasCap(global.location.href)) return [];
    const p = policy();
    if (Array.isArray(p.cap_perms)) return GP.normalizeCapPerms(p.cap_perms);
    if (Array.isArray(p.guest_perms)) return GP.normalizeCapPerms(p.guest_perms);
    return [];
  }

  function isSpaceSessionHost() {
    const isViewer = c().getIsViewer;
    if (isViewer && isViewer()) return false;
    const joinTok = c().getJoinTokenParam;
    if (joinTok && joinTok()) return false;
    if (urlHasCap(global.location.href)) return false;
    const AL = global.GriGsiSpaceActionLimits;
    if (AL && typeof AL.isGuest === "function" && AL.isGuest(policy())) return false;
    const secretFn = c().getSpaceSecret;
    const hasMarker = c().hasHostMarker;
    const secret = secretFn && typeof secretFn === "function" ? secretFn() : "";
    return !!(hasMarker && hasMarker(secret));
  }

  function guestHasDelegatePerm(perm) {
    if (isSpaceSessionHost()) return true;
    const GP = global.GriGsiCapGuestPerms;
    if (!GP) return false;
    const key = String(perm || "").toLowerCase().trim();
    const payload = resolveCapDelegatePayload();
    if (payload && GP.capAllowsPerm(payload, key)) return true;
    return capPermsFromPolicyOrPayload().includes(key);
  }

  function isHostAccessPolicyViewer() {
    return isSpaceSessionHost();
  }

  function setHostDockControlVisible(id, show) {
    const el = document.getElementById(id);
    if (!el) return;
    el.classList.toggle("hidden", !show);
    el.hidden = !show;
    el.setAttribute("aria-hidden", show ? "false" : "true");
  }

  function syncHostDockControls() {
    const ensureShare = c().ensureSpaceCodeShareButton;
    if (typeof ensureShare === "function") ensureShare();
    const hostSession = isSpaceSessionHost();
    const isViewer = c().getIsViewer && c().getIsViewer();
    const guestDelegate = !isViewer && !hostSession;
    try {
      document.body.classList.toggle("space-session-host", hostSession && !isViewer);
      document.body.classList.toggle("space-guest-delegate", guestDelegate);
    } catch (_) {}

    const chipFn = c().getAccessChipEl;
    const chip = chipFn && typeof chipFn === "function" ? chipFn() : null;

    if (isViewer) {
      setHostDockControlVisible("btn-space-share", false);
      setHostDockControlVisible("btn-space-add-viewer", false);
      setHostDockControlVisible("btn-space-dock-open", false);
      setHostDockControlVisible("btn-space-dock-new", false);
      setHostDockControlVisible("btn-settings", false);
      setHostDockControlVisible("btn-download-space-header", false);
      setHostDockControlVisible("btn-share-social", false);
      setHostDockControlVisible("btn-security-dropdown", false);
      if (chip) {
        chip.classList.add("hidden");
        chip.hidden = true;
        chip.setAttribute("aria-hidden", "true");
      }
      return;
    }

    const canInvite = guestHasDelegatePerm("invite");
    const canViewer = guestHasDelegatePerm("viewer");
    const canSettings = guestHasDelegatePerm("settings");

    setHostDockControlVisible("btn-space-share", canInvite);
    setHostDockControlVisible("btn-space-add-viewer", canViewer);
    setHostDockControlVisible("btn-settings", canSettings);
    setHostDockControlVisible("btn-download-space-header", canInvite);
    setHostDockControlVisible("btn-share-social", canInvite);
    setHostDockControlVisible("btn-security-dropdown", hostSession);

    const shareGuestPermsBlock = document.getElementById("instant-invite-guest-perms-block");
    if (shareGuestPermsBlock) {
      shareGuestPermsBlock.classList.toggle("hidden", guestDelegate);
      shareGuestPermsBlock.hidden = guestDelegate;
    }

    if (chip) {
      chip.classList.toggle("hidden", !canSettings);
      chip.hidden = !canSettings;
      chip.setAttribute("aria-hidden", canSettings ? "false" : "true");
    }
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    global.guestHasDelegatePerm = guestHasDelegatePerm;
    global.isSpaceSessionHost = isSpaceSessionHost;
    global.syncHostDockControls = syncHostDockControls;
    global.GriGsiSpaceGuestDelegate = {
      init,
      guestHasDelegatePerm,
      isSpaceSessionHost,
      syncHostDockControls,
      isHostAccessPolicyViewer,
      resolveCapDelegatePayload,
      capPermsFromPolicyOrPayload,
    };
    return global.GriGsiSpaceGuestDelegate;
  }

  global.GriGsiSpaceGuestDelegate = { init };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Space code field sizing + inline share button in code bar. */
(function (global) {
  let ctx = null;

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function getField() {
    const fn = c().getSpaceCodeEl;
    return fn && typeof fn === "function" ? fn() : document.getElementById("space-code");
  }

  function measureSpaceCodeTextWidth(field, text) {
    const cs = global.getComputedStyle(field);
    const canvas = document.createElement("canvas");
    const ctx2 = canvas.getContext("2d");
    if (!ctx2 || !text) return 0;
    ctx2.font = cs.fontStyle + " " + cs.fontVariant + " " + cs.fontWeight + " " + cs.fontSize + " " + cs.fontFamily;
    const base = ctx2.measureText(text).width;
    const fontSizePx = parseFloat(cs.fontSize) || 14;
    let letterSpacingPx = 0;
    if (cs.letterSpacing && cs.letterSpacing !== "normal") {
      if (cs.letterSpacing.endsWith("em")) letterSpacingPx = parseFloat(cs.letterSpacing) * fontSizePx;
      else letterSpacingPx = parseFloat(cs.letterSpacing) || 0;
    }
    const extra = text.length > 1 ? (text.length - 1) * letterSpacingPx : 0;
    return base + extra;
  }

  function resizeSpaceCodeField() {
    const field = getField();
    if (!field) return;
    if (document.querySelector(".space-share.chat-first-shell")) {
      field.style.width = "";
      field.style.minWidth = "";
      field.style.maxWidth = "";
      field.style.flex = "";
      field.style.height = "";
      field.style.overflowY = "hidden";
      field.style.overflowX = "hidden";
      field.scrollLeft = 0;
      return;
    }
    field.style.height = "";
    field.style.overflowY = "hidden";
    field.style.overflowX = "hidden";
    field.scrollLeft = 0;
    const fit = () => {
      const val = String(field.value || "").trim();
      const sample = val || String(field.placeholder || "").trim() || "1234";
      if (!sample) {
        field.style.width = "";
        field.style.minWidth = "";
        field.style.maxWidth = "";
        field.style.flex = "";
        return;
      }
      const textW = measureSpaceCodeTextWidth(field, sample);
      const charW = measureSpaceCodeTextWidth(field, "0") || 8;
      const cs = global.getComputedStyle(field);
      const padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      const borderX = (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.borderRightWidth) || 0);
      const contentW = textW + charW * 2;
      const boostedContentW = contentW * 1.15;
      const w = Math.ceil(boostedContentW + padX + borderX);
      field.style.flex = "0 0 auto";
      field.style.setProperty("width", w + "px", "important");
      field.style.setProperty("min-width", w + "px", "important");
      field.style.setProperty("max-width", w + "px", "important");
      field.style.setProperty("height", "", "important");
      field.style.setProperty("min-height", "", "important");
      field.style.setProperty("max-height", "", "important");
    };
    fit();
    requestAnimationFrame(fit);
  }

  function resetSpaceCodeFieldSize() {
    if (!getField()) return;
    resizeSpaceCodeField();
  }

  function openSpaceCodeShareSheet() {
    const L = global.GriGsiSpaceMediaLazy;
    const toast = c().showToast;
    if (L && typeof L.openInstantShare === "function") {
      void L.openInstantShare().then((ok) => {
        if (!ok && typeof toast === "function") {
          toast("Share panel is not available — reload the page.", "warning");
        }
      });
      return;
    }
    if (global.GriGsiInstantShare && typeof global.GriGsiInstantShare.openFromSpace === "function") {
      global.GriGsiInstantShare.openFromSpace();
      return;
    }
    if (typeof toast === "function") toast("Share panel is not available — reload the page.", "warning");
  }

  function ensureSpaceCodeShareButton() {
    const wrap = document.querySelector(".space-code-picker-wrap");
    if (!wrap) return null;
    let btn = document.getElementById("btn-space-code-share");
    if (!btn) {
      btn = document.createElement("button");
      btn.type = "button";
      btn.className = "space-code-share-btn";
      btn.id = "btn-space-code-share";
      btn.title = "Share — code, link, QR";
      btn.setAttribute("aria-label", "Share Space");
      btn.innerHTML = '<i class="fas fa-share-alt" aria-hidden="true"></i>';
      const renameBtn = document.getElementById("btn-space-local-rename");
      if (renameBtn) wrap.insertBefore(btn, renameBtn);
      else {
        const pickerBtn = document.getElementById("btn-space-code-picker");
        if (pickerBtn) wrap.insertBefore(btn, pickerBtn);
        else wrap.appendChild(btn);
      }
      btn.addEventListener("click", (e) => {
        e.stopPropagation();
        openSpaceCodeShareSheet();
      });
    }
    btn.classList.toggle("hidden", false);
    btn.hidden = false;
    btn.removeAttribute("hidden");
    btn.style.display = "inline-flex";
    btn.setAttribute("aria-hidden", "false");
    return btn;
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    global.GriGsiSpaceCodeBar = {
      init,
      measureSpaceCodeTextWidth,
      resizeSpaceCodeField,
      resetSpaceCodeFieldSize,
      openSpaceCodeShareSheet,
      ensureSpaceCodeShareButton,
    };
    return global.GriGsiSpaceCodeBar;
  }

  global.GriGsiSpaceCodeBar = { init };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Participants chip, modal list, presence indicator, sidebar panel toggle. */
(function (global) {
  let ctx = null;
  let wired = false;

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function call(name, args) {
    const fn = c()[name];
    return typeof fn === "function" ? fn.apply(null, args || []) : undefined;
  }

  function clearEl(el) {
    if (!el) return;
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  function appendIcon(el, className) {
    const i = document.createElement("i");
    i.className = className;
    el.appendChild(i);
    return i;
  }

  function updatePresenceIndicator() {
    const chip = document.getElementById("space-participants-chip");
    if (!chip) return;
    const label = document.getElementById("participant-chip-label");
    const remoteIds = call("getDisplayRemotePeerIds") || [];
    const remoteN = remoteIds.length;
    const viewerN = call("countRemoteViewers") || 0;
    const memberN = Math.max(0, remoteN - viewerN);
    const total = 1 + remoteN;

    chip.classList.remove("space-presence--others", "space-presence--alone", "space-presence--connecting");

    if (remoteN > 0) {
      chip.classList.add("space-presence--others");
      let text = total === 1 ? "1 in space" : total + " in space";
      if (viewerN > 0) text += " · " + viewerN + " viewer" + (viewerN === 1 ? "" : "s");
      if (label) label.textContent = text;
      chip.title =
        memberN === 1
          ? "One other person is connected. Tap to view participants."
          : remoteN + " others connected. Tap to view participants.";
      chip.setAttribute("aria-label", text + " — view participants");
    } else if (call("getPeerIsOpen")) {
      chip.classList.add("space-presence--alone");
      if (label) label.textContent = "Only you · 1";
      chip.title = "You are the only one here. Tap to view participants.";
      chip.setAttribute("aria-label", "Only you in space — view participants");
    } else {
      chip.classList.add("space-presence--connecting");
      if (label) label.textContent = "Connecting…";
      chip.title = "Connecting to the Space…";
      chip.setAttribute("aria-label", "Connecting — view participants");
    }
  }

  function buildParticipantListItem(rid, opts) {
    const o = opts && typeof opts === "object" ? opts : {};
    const isViewerRow = !!o.viewer;
    const participants = call("getParticipants") || [];
    const p = participants.find((x) => x.id === rid);
    const ridNorm = call("normalizePeerIdForMedia", [rid]);
    const hasConn = call("peerHasEstablishedSession", [ridNorm]);
    const nm =
      call("peerDisplayName", [rid]) ||
      (p ? p.name : call("anonymousNameForPeer", [rid]));
    let statusText = "Connecting…";
    if (hasConn) statusText = isViewerRow ? "watching" : "online";
    else if (p && p.status) statusText = p.status;

    const item = document.createElement("div");
    item.className = "participant-item" + (isViewerRow ? " is-viewer" : "");
    item.dataset.peer = String(rid);

    const avatar = document.createElement("div");
    avatar.className = "participant-avatar";
    avatar.textContent = (String(nm)[0] || "A").toUpperCase();

    const info = document.createElement("div");
    info.className = "participant-info";
    const nameEl = document.createElement("div");
    nameEl.className = "participant-name";
    nameEl.textContent = String(nm || "Guest");
    if (!isViewerRow) call("wirePeerLabelTap", [nameEl, rid]);
    if (isViewerRow) {
      const vb = document.createElement("span");
      vb.className = "participant-viewer-badge";
      vb.title = "Read-only viewer";
      appendIcon(vb, "fas fa-eye");
      vb.appendChild(document.createTextNode(" Viewer"));
      nameEl.appendChild(vb);
    }
    const st = document.createElement("div");
    st.className = "participant-status";
    st.textContent = statusText;
    info.appendChild(nameEl);
    info.appendChild(st);

    if (!isViewerRow) {
      const actionsWrap = document.createElement("div");
      actionsWrap.className = "participant-actions-row";
      const hint = call("getSharingHint", [rid]);
      const sharesScreen = call("getSharesScreen", [rid]);
      const isScreen = !!(hint && hint.screen) || !!sharesScreen;
      if (hint || sharesScreen) {
        const badge = document.createElement("span");
        badge.className = "participant-av-badge";
        badge.title = isScreen ? "Sharing screen" : "Sharing camera / video";
        appendIcon(badge, isScreen ? "fas fa-desktop" : "fas fa-video");
        actionsWrap.appendChild(badge);
      }
      const blocked = call("isLocallyBlockedRemoteMedia", [rid]);
      if (!blocked && call("getPeerIsOpen") && !call("hasRemoteVideoTileForPeer", [rid])) {
        const joinBtn = document.createElement("button");
        joinBtn.type = "button";
        joinBtn.className = "btn-participant-join-av";
        joinBtn.textContent = "Join";
        joinBtn.title = "Show their feed in the multiview";
        joinBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          call("joinPeerMedia", [rid]);
        });
        actionsWrap.appendChild(joinBtn);
      }
      if (actionsWrap.childNodes.length) info.appendChild(actionsWrap);
    }

    item.appendChild(avatar);
    item.appendChild(info);

    const isViewer = !!call("getIsViewer");
    if (isViewerRow && !isViewer) {
      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "btn-remove-viewer";
      removeBtn.textContent = "Remove";
      removeBtn.title = "Remove viewer from this Space";
      removeBtn.addEventListener("click", () => {
        if (confirm("Remove this viewer? They will lose access.")) call("removeViewerParticipant", [rid]);
      });
      item.appendChild(removeBtn);
    } else if (!isViewerRow) {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.dataset.peer = String(rid);
      const blocked = call("isLocallyBlockedRemoteMedia", [rid]);
      if (blocked) {
        btn.className = "btn-resume-participant-media";
        btn.title = "Resume camera and sound from this person";
        btn.textContent = "Resume";
        btn.addEventListener("click", () => {
          const id = btn.dataset.peer;
          if (id) call("resumeRemoteMedia", [id]);
        });
      } else {
        btn.className = "btn-remove-participant";
        btn.title = "Stop receiving camera/screen and sound — person stays in the Space";
        appendIcon(btn, "fas fa-times");
        btn.appendChild(document.createTextNode(" Stop AV"));
        btn.addEventListener("click", () => {
          const id = btn.dataset.peer;
          if (id && confirm("Stop video and audio from this person? They stay in the Space."))
            call("stopRemoteVideoStream", [id]);
        });
      }
      item.appendChild(btn);
    }

    return item;
  }

  function updateParticipantsList() {
    const memberLists = [
      document.getElementById("participants-list"),
      document.getElementById("space-participants-modal-list"),
    ].filter(Boolean);
    const viewerList = document.getElementById("space-participants-viewers-list");
    const viewerHeading = document.getElementById("space-participants-viewers-heading");
    const participantsCount = document.getElementById("participants-count");
    const participants = call("getParticipants") || [];
    const allRemote = (call("getDisplayRemotePeerIds") || []).slice().sort();
    participants.forEach((p) => {
      if (p.id !== "local" && !allRemote.includes(p.id)) {
        const n = call("normalizePeerIdForMedia", [p.id]);
        if (n && call("peerHasEstablishedSession", [p.id]) && !allRemote.includes(n)) allRemote.push(p.id);
      }
    });
    const memberIds = allRemote.filter((rid) => {
      const px = participants.find((x) => x.id === rid);
      return !px || px.role !== "viewer";
    });
    const viewerIds = allRemote.filter((rid) => {
      const px = participants.find((x) => x.id === rid);
      return px && px.role === "viewer";
    });
    const effectiveCount = 1 + allRemote.length;

    if (participantsCount) {
      const numEl = participantsCount.querySelector(".participants-badge-num");
      if (numEl) numEl.textContent = String(effectiveCount);
      const wordEl = participantsCount.querySelector(".participants-badge-word");
      if (wordEl) wordEl.textContent = effectiveCount === 1 ? "participant" : "participants";
    }
    updatePresenceIndicator();

    if (!memberLists.length && !viewerList) return;

    memberLists.forEach((list) => {
      clearEl(list);
      const localP = participants.find((p) => p.id === "local");
      if (localP) {
        const item = document.createElement("div");
        item.className = "participant-item";
        item.dataset.peer = "local";
        const avatar = document.createElement("div");
        avatar.className = "participant-avatar";
        const nm = String(localP.name || "You");
        avatar.textContent = (nm[0] || "Y").toUpperCase();
        const info = document.createElement("div");
        info.className = "participant-info";
        const nameEl = document.createElement("div");
        nameEl.className = "participant-name";
        nameEl.textContent = nm;
        const st = document.createElement("div");
        st.className = "participant-status";
        st.textContent = String(localP.status || "");
        info.appendChild(nameEl);
        info.appendChild(st);
        item.appendChild(avatar);
        item.appendChild(info);
        list.appendChild(item);
      }
      memberIds.forEach((rid) => list.appendChild(buildParticipantListItem(rid, { viewer: false })));
    });

    if (viewerList) {
      clearEl(viewerList);
      viewerIds.forEach((rid) => viewerList.appendChild(buildParticipantListItem(rid, { viewer: true })));
      const hasViewers = viewerIds.length > 0;
      viewerList.classList.toggle("hidden", !hasViewers);
      if (viewerHeading) viewerHeading.classList.toggle("hidden", !hasViewers);
    }
  }

  function openParticipantsModal() {
    const participantsModal = document.getElementById("space-participants-modal");
    const participantsChip = document.getElementById("space-participants-chip");
    if (!participantsModal) return;
    void global.GriGsiSpaceMediaLazy?.ensureConnectBridge?.();
    void global.GriGsiSpaceMediaLazy?.ensureLanDiscovery?.();
    participantsModal.classList.add("active");
    if (participantsChip) participantsChip.setAttribute("aria-expanded", "true");
    updateParticipantsList();
  }

  function closeParticipantsModal() {
    const participantsModal = document.getElementById("space-participants-modal");
    const participantsChip = document.getElementById("space-participants-chip");
    if (!participantsModal) return;
    participantsModal.classList.remove("active");
    if (participantsChip) participantsChip.setAttribute("aria-expanded", "false");
  }

  function wireControls() {
    if (wired) return;
    wired = true;
    const participantsModal = document.getElementById("space-participants-modal");
    const participantsBackdrop = document.getElementById("participants-backdrop");
    const participantsChip = document.getElementById("space-participants-chip");

    participantsChip?.addEventListener("click", openParticipantsModal);
    document.getElementById("close-space-participants-modal")?.addEventListener("click", closeParticipantsModal);
    participantsModal?.addEventListener("click", (e) => {
      if (e.target === participantsModal) closeParticipantsModal();
    });
    global.addEventListener("grigsi-space-viewers-changed", () => updateParticipantsList());

    document.getElementById("btn-manage-participants")?.addEventListener("click", () => {
      const sidebar = document.querySelector(".space-sidebar");
      const mq = global.matchMedia("(max-width: 1024px)");
      const spaceShareEl = call("getSpaceShareEl");
      if (mq.matches) {
        spaceShareEl?.classList.toggle("participants-panel-open");
        if (participantsBackdrop) {
          participantsBackdrop.setAttribute(
            "aria-hidden",
            spaceShareEl?.classList.contains("participants-panel-open") ? "false" : "true"
          );
        }
      } else if (sidebar) {
        sidebar.scrollIntoView({ behavior: "smooth", block: "nearest" });
        try {
          document.getElementById("space-participants-modal-list")?.firstElementChild?.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        } catch (_) {}
      }
    });
    participantsBackdrop?.addEventListener("click", () => {
      const spaceShareEl = call("getSpaceShareEl");
      spaceShareEl?.classList.remove("participants-panel-open");
      participantsBackdrop.setAttribute("aria-hidden", "true");
    });
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    wireControls();
    global.GriGsiSpaceParticipantsUi = {
      init,
      updatePresenceIndicator,
      updateParticipantsList,
      openParticipantsModal,
      closeParticipantsModal,
    };
    return global.GriGsiSpaceParticipantsUi;
  }

  global.GriGsiSpaceParticipantsUi = { init };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Video grid layout — feed count, empty-remote shells, focus mode, tile click, FS exit chrome. */
(function (global) {
  let ctx = null;
  let wired = false;
  let videoFocusPeerId = null;

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function call(name, args) {
    const fn = c()[name];
    return typeof fn === "function" ? fn.apply(null, args || []) : undefined;
  }

  function videoGrid() {
    return call("getVideoGrid");
  }

  function appendIcon(el, className) {
    const i = document.createElement("i");
    i.className = className;
    el.appendChild(i);
    return i;
  }

  function localVideoTileIsActive() {
    const localVideo = call("getLocalVideo");
    const screenStream = call("getScreenStream");
    const localStream = call("getLocalStream");
    const isDisplayCaptureStream = c().isDisplayCaptureStream;
    if (!localVideo) return false;
    if (
      screenStream &&
      screenStream.getVideoTracks().some((t) => t && t.readyState === "live" && t.enabled)
    ) {
      return true;
    }
    try {
      const so = localVideo.srcObject;
      if (so && typeof so.getVideoTracks === "function") {
        const vids = so.getVideoTracks().filter((t) => t && t.readyState === "live");
        if (vids.length) {
          if (isDisplayCaptureStream && isDisplayCaptureStream(so)) return true;
          if (vids.some((t) => t.enabled)) return true;
        }
      }
    } catch (_) {}
    if (!localStream) return false;
    const vt = localStream.getVideoTracks().filter((t) => t && t.readyState === "live");
    if (!vt.length) return false;
    if (isDisplayCaptureStream && isDisplayCaptureStream(localStream)) return true;
    return vt.some((t) => t.enabled);
  }

  function remoteVideoTileHasVisiblePicture(tile) {
    const isMeshPlaceholderVideoTrack = c().isMeshPlaceholderVideoTrack;
    if (!tile || tile.classList.contains("local") || tile.classList.contains("video-tile--audio-only")) {
      return false;
    }
    const video = tile.querySelector(
      ".remote-video-shell video, video:not(#local-video):not(.local-screen-preview)"
    );
    if (!video) return false;
    try {
      if (video.videoWidth > 0 && video.videoHeight > 0) return true;
      const so = video.srcObject;
      if (so && typeof so.getVideoTracks === "function") {
        return so.getVideoTracks().some(
          (t) =>
            t &&
            t.readyState !== "ended" &&
            t.enabled &&
            !(isMeshPlaceholderVideoTrack && isMeshPlaceholderVideoTrack(t))
        );
      }
    } catch (_) {}
    return false;
  }

  function countVisibleRemoteVideoTiles() {
    const grid = videoGrid();
    if (!grid) return 0;
    let n = 0;
    grid
      .querySelectorAll(".video-tile[data-peer]:not(.local):not(.video-tile--audio-only)")
      .forEach((tile) => {
        if (remoteVideoTileHasVisiblePicture(tile)) n += 1;
      });
    return n;
  }

  function getVideoGridFeedCount() {
    const grid = videoGrid();
    if (!grid) return 0;
    return countVisibleRemoteVideoTiles() + (localVideoTileIsActive() ? 1 : 0);
  }

  function syncVideoFocusBackChrome() {
    const grid = videoGrid();
    const btnVideoFocusBack = document.getElementById("btn-video-focus-back");
    const btnVideoShowAll = call("getBtnVideoShowAll");
    const focused = !!(grid && grid.classList.contains("video-grid--focus"));
    if (btnVideoFocusBack) btnVideoFocusBack.classList.toggle("hidden", !focused);
    if (btnVideoShowAll) btnVideoShowAll.classList.toggle("hidden", !focused);
  }

  function applyVideoGridFocus() {
    const grid = videoGrid();
    if (!grid) return;
    grid
      .querySelectorAll(".video-tile[data-peer]:not(.local):not(.video-tile--audio-only)")
      .forEach((tile) => {
        const hasPic = remoteVideoTileHasVisiblePicture(tile);
        tile.classList.toggle("video-tile--empty-remote", !hasPic);
      });
    const feedCount = getVideoGridFeedCount();
    if (videoFocusPeerId === "local" && !localVideoTileIsActive()) videoFocusPeerId = null;
    if (videoFocusPeerId && videoFocusPeerId !== "local") {
      const still = grid.querySelector(
        '.video-tile[data-peer="' +
          String(videoFocusPeerId).replace(/\\/g, "\\\\").replace(/"/g, '\\"') +
          '"]'
      );
      if (!still || still.classList.contains("video-tile--empty-remote")) videoFocusPeerId = null;
    }
    const canFocus = feedCount >= 2;
    if (!canFocus) videoFocusPeerId = null;
    if (!canFocus || videoFocusPeerId == null) {
      grid.classList.remove("video-grid--focus");
      grid.querySelectorAll(".video-tile").forEach((el) => el.classList.remove("video-tile--focused"));
    } else {
      grid.classList.add("video-grid--focus");
      grid.querySelectorAll(".video-tile").forEach((el) => {
        const isLocal = el.classList.contains("local");
        const pid = isLocal ? "local" : el.getAttribute("data-peer");
        const focused = String(videoFocusPeerId) === String(pid || "");
        el.classList.toggle("video-tile--focused", focused);
      });
    }
    syncVideoFocusBackChrome();
    const fillLayout = feedCount === 1 || grid.classList.contains("video-grid--focus");
    grid.classList.toggle("video-grid--fill", fillLayout);
    grid.classList.toggle("video-grid--multi", feedCount >= 2);
  }

  function clearVideoFocus() {
    videoFocusPeerId = null;
    applyVideoGridFocus();
  }

  function clearFocusIfPeer(peerId) {
    const normFn = c().normalizePeerIdForMedia;
    const pid = normFn ? normFn(peerId) : String(peerId || "").trim();
    if (videoFocusPeerId && normFn && normFn(videoFocusPeerId) === pid) videoFocusPeerId = null;
  }

  function setVideoFocusFromTile(tile) {
    if (!tile || getVideoGridFeedCount() < 2) return;
    if (tile.classList.contains("local")) {
      if (!localVideoTileIsActive()) return;
      videoFocusPeerId = "local";
    } else {
      const pid = tile.getAttribute("data-peer");
      if (!pid) return;
      videoFocusPeerId = pid;
    }
    applyVideoGridFocus();
  }

  function exitAnyDocumentFullscreen() {
    try {
      if (document.fullscreenElement && document.exitFullscreen) return document.exitFullscreen();
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        return document.webkitExitFullscreen();
      }
    } catch (_) {}
    return Promise.resolve();
  }

  function syncTileFullscreenExitChrome() {
    const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
    let btn = document.getElementById("btn-tile-fs-exit");
    if (fsEl && fsEl.classList && fsEl.classList.contains("video-tile")) {
      if (!btn) {
        btn = document.createElement("button");
        btn.type = "button";
        btn.id = "btn-tile-fs-exit";
        btn.className = "video-tile-fs-exit";
        btn.title = "Exit fullscreen";
        btn.setAttribute("aria-label", "Exit fullscreen");
        appendIcon(btn, "fas fa-times");
        btn.appendChild(document.createTextNode(" Exit"));
        btn.addEventListener("click", (ev) => {
          ev.stopPropagation();
          exitAnyDocumentFullscreen().finally(() => clearVideoFocus());
        });
        document.body.appendChild(btn);
      }
      btn.classList.remove("hidden");
    } else if (btn) {
      btn.classList.add("hidden");
    }
  }

  function onDocumentFullscreenChanged() {
    syncTileFullscreenExitChrome();
    call("syncStageFullscreenExitChrome");
  }

  function wireControls() {
    if (wired) return;
    wired = true;
    const grid = videoGrid();
    const btnVideoShowAll = call("getBtnVideoShowAll");
    const btnVideoFocusBack = document.getElementById("btn-video-focus-back");

    if (grid) {
      grid.addEventListener("click", (e) => {
        if (e.target.closest("button, a, input, label, .remote-video-control-overlay")) return;
        const tile = e.target.closest(".video-tile");
        if (!tile || tile.classList.contains("video-tile--empty-remote")) return;
        const feedCount = getVideoGridFeedCount();
        if (feedCount < 2) return;
        const isLocal = tile.classList.contains("local");
        const pid = isLocal ? "local" : tile.getAttribute("data-peer");
        if (grid.classList.contains("video-grid--focus") && String(videoFocusPeerId) === String(pid || "")) {
          clearVideoFocus();
          return;
        }
        setVideoFocusFromTile(tile);
      });
    }
    if (btnVideoShowAll) btnVideoShowAll.addEventListener("click", () => clearVideoFocus());
    if (btnVideoFocusBack) btnVideoFocusBack.addEventListener("click", () => clearVideoFocus());
    document.addEventListener("fullscreenchange", onDocumentFullscreenChanged);
    document.addEventListener("webkitfullscreenchange", onDocumentFullscreenChanged);
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    wireControls();
    global.GriGsiSpaceVideoGridLayout = {
      init,
      apply: applyVideoGridFocus,
      applyVideoGridFocus,
      clearFocus: clearVideoFocus,
      clearVideoFocus,
      setFocusFromTile: setVideoFocusFromTile,
      setVideoFocusFromTile,
      clearFocusIfPeer,
      localVideoTileIsActive,
      remoteVideoTileHasVisiblePicture,
      getFeedCount: getVideoGridFeedCount,
      getVideoGridFeedCount,
    };
    return global.GriGsiSpaceVideoGridLayout;
  }

  global.GriGsiSpaceVideoGridLayout = { init };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Local-only peer display labels — storage, rename UI, chat/participant refresh. */
(function (global) {
  const LABELS_PREFIX = "grigsi_space_peer_labels_";
  let ctx = null;
  let labelsById = new Map();

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }

  function call(name, args) {
    const fn = c()[name];
    return typeof fn === "function" ? fn.apply(null, args || []) : undefined;
  }

  function storageKey() {
    const codeFn = c().getSpaceCode;
    const k = String((codeFn && codeFn()) || "")
      .trim()
      .toLowerCase();
    return LABELS_PREFIX + (k || "unknown");
  }

  function loadFromStorage() {
    try {
      const raw = global.localStorage.getItem(storageKey());
      const obj = raw ? JSON.parse(raw) : {};
      labelsById = new Map();
      if (obj && typeof obj === "object") {
        Object.keys(obj).forEach((pid) => {
          const lbl = String(obj[pid] || "").trim();
          if (lbl) labelsById.set(pid, lbl.slice(0, 48));
        });
      }
    } catch (_) {
      labelsById = new Map();
    }
  }

  function persistLabels() {
    try {
      const obj = {};
      labelsById.forEach((v, k) => {
        if (v) obj[k] = v;
      });
      global.localStorage.setItem(storageKey(), JSON.stringify(obj));
    } catch (_) {}
  }

  function getLocalLabel(peerId) {
    const normFn = c().normalizePeerIdForMedia;
    const pid = normFn ? normFn(peerId) : String(peerId || "").trim();
    const raw = String(peerId || "").trim();
    return (pid && labelsById.get(pid)) || (raw && labelsById.get(raw)) || "";
  }

  function applyPeerLocalLabelToUI(peerId) {
    const normFn = c().normalizePeerIdForMedia;
    const pid = (normFn ? normFn(peerId) : null) || String(peerId || "").trim();
    if (!pid) return;
    const displayFn = c().peerDisplayName;
    const display = displayFn ? displayFn(peerId) : getLocalLabel(peerId);

    document.querySelectorAll(".chat-message.received[data-from-peer]").forEach((row) => {
      const rowPid = row.dataset.fromPeer;
      if (!rowPid || (normFn ? normFn(rowPid) : rowPid) !== pid) return;
      const senderEl = row.querySelector(".peer-label-name, .sender");
      if (senderEl) {
        senderEl.textContent = display;
        senderEl.title = "Tap to rename — only you see this label";
      }
    });

    try {
      const loadFn = c().loadChatJournal;
      const saveFn = c().saveChatJournal;
      if (loadFn && saveFn && displayFn) {
        const list = loadFn();
        let changed = false;
        list.forEach((e) => {
          if (!e || e.sent || !e.fromPeer) return;
          if ((normFn ? normFn(e.fromPeer) : e.fromPeer) !== pid) return;
          const next = displayFn(e.fromPeer);
          if (e.sender !== next) {
            e.sender = next;
            changed = true;
          }
        });
        if (changed) saveFn(list);
      }
    } catch (_) {}

    try {
      const N = global.GriGsiSpaceChatNotices;
      if (N && N.refreshPeerLabel) N.refreshPeerLabel(peerId);
    } catch (_) {}

    call("updateParticipantsList");
  }

  function setLocalLabel(peerId, label) {
    const normFn = c().normalizePeerIdForMedia;
    const pid = (normFn ? normFn(peerId) : null) || String(peerId || "").trim();
    if (!pid) return false;
    const trimmed = String(label || "").trim().slice(0, 48);
    if (!trimmed) {
      labelsById.delete(pid);
      const raw = String(peerId || "").trim();
      if (raw && raw !== pid) labelsById.delete(raw);
    } else {
      labelsById.set(pid, trimmed);
    }
    persistLabels();
    applyPeerLocalLabelToUI(pid);
    return true;
  }

  function beginPeerLabelEdit(anchorEl, peerId) {
    if (!anchorEl || !peerId || peerId === "local") return;
    if (anchorEl.dataset.editingPeerLabel === "1") return;
    anchorEl.dataset.editingPeerLabel = "1";
    const displayFn = c().peerDisplayName;
    const input = document.createElement("input");
    input.type = "text";
    input.className = "peer-label-input participant-rename-input";
    input.value = displayFn ? displayFn(peerId) : getLocalLabel(peerId);
    input.maxLength = 48;
    input.placeholder = "Name (only you see this)";
    input.setAttribute("aria-label", "Peer name — only you see this");

    const parent = anchorEl.parentNode;
    const next = anchorEl.nextSibling;
    anchorEl.classList.add("hidden");
    parent.insertBefore(input, next);
    input.focus();
    input.select();

    let done = false;
    const finish = (save) => {
      if (done) return;
      done = true;
      if (save) setLocalLabel(peerId, input.value);
      input.remove();
      anchorEl.classList.remove("hidden");
      anchorEl.textContent = displayFn ? displayFn(peerId) : getLocalLabel(peerId);
      delete anchorEl.dataset.editingPeerLabel;
      const item = anchorEl.closest(".participant-item");
      if (item) {
        const av = item.querySelector(".participant-avatar");
        const nm = displayFn ? displayFn(peerId) : getLocalLabel(peerId);
        if (av) av.textContent = (String(nm)[0] || "A").toUpperCase();
      }
    };

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        finish(true);
      }
      if (e.key === "Escape") {
        e.preventDefault();
        finish(false);
      }
    });
    input.addEventListener("blur", () => finish(true));
  }

  function wirePeerLabelTap(el, peerId) {
    if (!el || !peerId || peerId === "local") return;
    el.classList.add("peer-label-name");
    el.setAttribute("role", "button");
    el.setAttribute("tabindex", "0");
    el.title = "Tap to rename — only you see this label";
    el.dataset.peer = String(peerId);
    const startEdit = (e) => {
      e.preventDefault();
      e.stopPropagation();
      beginPeerLabelEdit(el, peerId);
    };
    el.addEventListener("click", startEdit);
    el.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") startEdit(e);
    });
  }

  function init(context) {
    ctx = context && typeof context === "object" ? context : {};
    loadFromStorage();
    global.GriGsiSpacePeerLabels = {
      init,
      getLocalLabel,
      setLocalLabel,
      wirePeerLabelTap,
      applyPeerLocalLabelToUI,
    };
    return global.GriGsiSpacePeerLabels;
  }

  global.GriGsiSpacePeerLabels = { init };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Remote PGM video tiles — debounced rebuild, patch-in-place, stream track wiring. */
(function (global) {
  let ctx = null;
  const remoteStreamsTrackWired = new WeakSet();
  const REMOTE_PGM_REBUILD_DEBOUNCE_MS = 220;
  const remotePgmRebuildDebounce = new Map();
  const remotePgmLastAppliedSig = new Map();
  const remotePgmEmptyRemoveTimeouts = new Map();

  function c() {
    return ctx && typeof ctx === "object" ? ctx : {};
  }
  function call(name, args) {
    const fn = c()[name];
    return typeof fn === "function" ? fn.apply(null, args || []) : undefined;
  }
  function grid() {
    return call("getVideoGrid");
  }
  function norm(peerId) {
    return call("normalizePeerIdForMedia", [peerId]);
  }
  function appendIcon(el, className) {
    const i = document.createElement("i");
    i.className = className;
    el.appendChild(i);
    return i;
  }
  function peerAttrEsc(pid) {
    return typeof CSS !== "undefined" && CSS.escape
      ? CSS.escape(String(pid))
      : String(pid).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  }

function buildPgmCompositeSig(stream) {
  if (!stream || typeof stream.getVideoTracks !== 'function') return '';
  try {
    const vPart = stream
      .getVideoTracks()
      .filter((t) => t && t.readyState !== 'ended')
      .map((t) => `${t.id}:${t.readyState}`)
      .sort()
      .join('|');
    const aPart = stream
      .getAudioTracks()
      .filter((t) => t && t.readyState !== 'ended')
      .map((t) => t.id)
      .sort()
      .join('|');
    return `${vPart}#${aPart}`;
  } catch (_) {
    return '';
  }
}

function buildPgmAudioSigFromComposite(compositeSig) {
  const parts = String(compositeSig || '').split('#');
  return parts.length > 1 ? parts.slice(1).join('#') : '';
}

function buildPgmVideoSigFromComposite(compositeSig) {
  return String(compositeSig || '').split('#')[0] || '';
}

function buildPgmPairAudioSig(camSig, scrSig) {
  return `${buildPgmAudioSigFromComposite(camSig)}##${buildPgmAudioSigFromComposite(scrSig)}`;
}

function buildPgmPairVideoSig(camSig, scrSig) {
  return `${buildPgmVideoSigFromComposite(camSig)}##${buildPgmVideoSigFromComposite(scrSig)}`;
}

function remoteTileAudioTrackSig(audioEl) {
  try {
    const so = audioEl && audioEl.srcObject;
    if (!so || typeof so.getAudioTracks !== 'function') return '';
    return so
      .getAudioTracks()
      .filter((t) => t && t.readyState !== 'ended')
      .map((t) => t.id)
      .sort()
      .join('|');
  } catch (_) {
    return '';
  }
}

function streamAudioTrackSig(stream) {
  try {
    if (!stream || typeof stream.getAudioTracks !== 'function') return '';
    return stream
      .getAudioTracks()
      .filter((t) => t && t.readyState !== 'ended')
      .map((t) => t.id)
      .sort()
      .join('|');
  } catch (_) {
    return '';
  }
}

/**
 * Camera on/off must not tear down `<audio.remote-peer-audio>` — only refresh the video shell.
 * Returns true when the existing tile was patched in place (audio element untouched).
 */
function patchRemotePeerTileVideoOnly(peerId, displayStream, opts) {
  if (!grid() || !displayStream) return false;
  const pid = norm(peerId);
  const peerAttr =
    typeof CSS !== 'undefined' && CSS.escape
      ? CSS.escape(String(pid))
      : String(pid).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  const tile = grid().querySelector(`.video-tile[data-peer="${peerAttr}"]`);
  if (!tile) return false;

  const rawFeed = opts && opts.feed;
  const feed =
    rawFeed === 'screen' ? 'screen' : rawFeed === 'camera' ? 'camera' : rawFeed === 'pgm' ? 'pgm' : '';
  const vids = displayStream
    .getVideoTracks()
    .filter((t) => t && t.readyState !== 'ended' && !call('isMeshPlaceholderVideoTrack', [t]));
  const auds = displayStream.getAudioTracks().filter((t) => t && t.readyState !== 'ended');
  const audioOnlyTile = vids.length === 0 && auds.length > 0;
  const existingAudio = tile.querySelector('audio.remote-peer-audio');
  const wantAudioSig = streamAudioTrackSig(displayStream);
  if (wantAudioSig) {
    const haveAudioSig = remoteTileAudioTrackSig(existingAudio);
    if (!existingAudio || haveAudioSig !== wantAudioSig) return false;
  } else if (existingAudio) {
    return false;
  }

  if (feed) tile.dataset.feed = feed;
  tile.classList.toggle('video-tile--audio-only', audioOnlyTile);

  let shell = tile.querySelector('.remote-video-shell');
  if (audioOnlyTile) {
    if (shell) shell.remove();
    call('applyVideoGridFocus');
    try {
      call('updateParticipantsList');
    } catch (_) {}
    return true;
  }

  const videoStream = new MediaStream(vids);
  if (!shell) {
    shell = document.createElement('div');
    shell.className = 'remote-video-shell';
    const insertBefore = existingAudio || tile.firstChild;
    if (insertBefore) tile.insertBefore(shell, insertBefore);
    else tile.appendChild(shell);
  }

  let video = shell.querySelector('video');
  if (!video) {
    video = document.createElement('video');
    video.muted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    shell.appendChild(video);
  } else {
    video.style.display = '';
  }

  if (feed !== 'screen' && vids.length > 0) {
    const primary = displayStream;
    const secondary = videoStream;
    try {
      video.srcObject = primary;
    } catch (_) {
      try {
        video.srcObject = videoStream;
      } catch (_) {}
    }
    const trySwapIfStillBlack = () => {
      try {
        if (video.videoWidth === 0 && secondary) {
          video.srcObject = secondary;
          video.play().catch(() => {});
        }
      } catch (_) {}
    };
    setTimeout(trySwapIfStillBlack, 350);
    setTimeout(trySwapIfStillBlack, 1200);
  } else {
    video.srcObject = videoStream;
  }

  try {
    call('applyRemoteCameraMirrorToVideoEl', [video, pid, feed, displayStream, shell]);
  } catch (_) {}
  try {
    video.play().catch(() => {});
  } catch (_) {}
  try {
    vids.forEach((t) => {
      if (!t) return;
      const nudge = () => {
        try {
          video.play();
        } catch (_) {}
      };
      t.addEventListener('unmute', nudge);
      t.addEventListener('ended', nudge);
    });
  } catch (_) {}

  call('applyVideoGridFocus');
  try {
    call('updateParticipantsList');
  } catch (_) {}
  return true;
}

function cleanupRemotePgmSchedulersForPeer(peerId) {
  const key = String(norm(peerId) || peerId);
  const prev = remotePgmRebuildDebounce.get(key);
  if (prev !== undefined) {
    try {
      clearTimeout(prev);
    } catch (_) {}
    remotePgmRebuildDebounce.delete(key);
  }
  remotePgmLastAppliedSig.delete(key);
  const pendingEmpty = remotePgmEmptyRemoveTimeouts.get(key);
  if (pendingEmpty !== undefined) {
    try {
      clearTimeout(pendingEmpty);
    } catch (_) {}
    remotePgmEmptyRemoveTimeouts.delete(key);
  }
}

function scheduleRebuildRemotePeerPgm(peerId) {
  const key = String(norm(peerId) || peerId);
  const prev = remotePgmRebuildDebounce.get(key);
  if (prev !== undefined) {
    try {
      clearTimeout(prev);
    } catch (_) {}
  }
  const t = setTimeout(() => {
    remotePgmRebuildDebounce.delete(key);
    try {
      rebuildRemotePeerPgmTile(key);
    } catch (_) {}
  }, REMOTE_PGM_REBUILD_DEBOUNCE_MS);
  remotePgmRebuildDebounce.set(key, t);
}

function rebuildRemotePeerPgmTile(peerId) {
  const pid = norm(peerId);
  const peerAttr =
    typeof CSS !== 'undefined' && CSS.escape
      ? CSS.escape(String(pid))
      : String(pid).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  try {
    call('clearRemoteSharingIntent', [pid]);
  } catch (_) {}
  const camStream = call('buildRemoteAvViewerStream', [pid]);
  const scrStream = call('buildRemoteScreenViewerStream', [pid]);
  const hasCamVid = camStream.getVideoTracks().some((t) => t && t.readyState !== 'ended');
  const hasCamAudio = camStream.getAudioTracks().some((t) => t && t.readyState !== 'ended');
  const showCamTile = hasCamVid || hasCamAudio;
  const hasScrVid = scrStream.getVideoTracks().some((t) => t && t.readyState !== 'ended');
  if (!showCamTile && !hasScrVid) {
    const pendingRm = remotePgmEmptyRemoveTimeouts.get(pid);
    if (pendingRm !== undefined) {
      try {
        clearTimeout(pendingRm);
      } catch (_) {}
    }
    const tid = setTimeout(() => {
      remotePgmEmptyRemoveTimeouts.delete(pid);
      const c2 = call('buildRemoteAvViewerStream', [pid]);
      const s2 = call('buildRemoteScreenViewerStream', [pid]);
      const v2 =
        c2.getVideoTracks().some((t) => t && t.readyState !== 'ended') ||
        c2.getAudioTracks().some((t) => t && t.readyState !== 'ended') ||
        s2.getVideoTracks().some((t) => t && t.readyState !== 'ended');
      if (!v2) {
        document.querySelectorAll(`.video-tile[data-peer="${peerAttr}"]`).forEach((el) => el.remove());
        remotePgmLastAppliedSig.delete(pid);
        call('applyVideoGridFocus');
        try {
          call('updateParticipantsList');
        } catch (_) {}
      }
    }, 320);
    remotePgmEmptyRemoveTimeouts.set(pid, tid);
    return;
  }
  const pendingRm = remotePgmEmptyRemoveTimeouts.get(pid);
  if (pendingRm !== undefined) {
    try {
      clearTimeout(pendingRm);
    } catch (_) {}
    remotePgmEmptyRemoveTimeouts.delete(pid);
  }
  const camSig = buildPgmCompositeSig(camStream);
  const scrSig = buildPgmCompositeSig(scrStream);
  const sig = `${camSig}##${scrSig}`;
  const audioSig = buildPgmPairAudioSig(camSig, scrSig);
  const videoSig = buildPgmPairVideoSig(camSig, scrSig);
  const hasTile = !!(grid() && grid().querySelector(`.video-tile[data-peer="${peerAttr}"]`));
  if (hasTile && remotePgmLastAppliedSig.get(pid) === sig) {
    try {
      document.querySelectorAll(`.video-tile[data-peer="${peerAttr}"] video`).forEach((el) => {
        try {
          el.play();
        } catch (_) {}
      });
    } catch (_) {}
    return;
  }
  const prevSig = remotePgmLastAppliedSig.get(pid);
  const prevAudioSig = prevSig
    ? buildPgmPairAudioSig(
        String(prevSig).split('##')[0] || '',
        String(prevSig).split('##')[1] || ''
      )
    : '';
  const prevVideoSig = prevSig
    ? buildPgmPairVideoSig(
        String(prevSig).split('##')[0] || '',
        String(prevSig).split('##')[1] || ''
      )
    : '';
  const remoteCountBefore = grid() ? grid().querySelectorAll('.video-tile[data-peer]:not(.local)').length : 0;
  const displayStream = new MediaStream();
  try {
    if (hasScrVid) {
      scrStream.getVideoTracks().forEach((t) => {
        if (t && t.readyState !== 'ended') displayStream.addTrack(t);
      });
    } else if (showCamTile) {
      camStream.getVideoTracks().forEach((t) => {
        if (t && t.readyState !== 'ended') displayStream.addTrack(t);
      });
    }
    const audioIds = new Set();
    [camStream, scrStream].forEach((s) => {
      if (!s || typeof s.getAudioTracks !== 'function') return;
      s.getAudioTracks().forEach((t) => {
        if (t && t.readyState !== 'ended' && !audioIds.has(t.id)) {
          audioIds.add(t.id);
          displayStream.addTrack(t);
        }
      });
    });
  } catch (_) {}
  const hasOutVid = displayStream.getVideoTracks().some((t) => t && t.readyState !== 'ended');
  const hasOutAud = displayStream.getAudioTracks().some((t) => t && t.readyState !== 'ended');
  if (
    hasTile &&
    hasOutAud &&
    audioSig &&
    audioSig === prevAudioSig &&
    videoSig !== prevVideoSig &&
    patchRemotePeerTileVideoOnly(pid, displayStream, { feed: hasScrVid ? 'screen' : 'camera' })
  ) {
    remotePgmLastAppliedSig.set(pid, sig);
    const remoteCountAfter = grid() ? grid().querySelectorAll('.video-tile[data-peer]:not(.local)').length : 0;
    if (remoteCountAfter > remoteCountBefore && remoteCountAfter >= 2) call('clearVideoFocus');
    return;
  }
  remotePgmLastAppliedSig.set(pid, sig);
  let preserveAudioEl = null;
  if (hasOutAud && audioSig && audioSig === prevAudioSig) {
    const existingTile = grid() && grid().querySelector(`.video-tile[data-peer="${peerAttr}"]`);
    const oldAud = existingTile && existingTile.querySelector('audio.remote-peer-audio');
    const wantSig = streamAudioTrackSig(displayStream);
    if (oldAud && remoteTileAudioTrackSig(oldAud) === wantSig && wantSig) {
      preserveAudioEl = oldAud;
      try {
        preserveAudioEl.remove();
      } catch (_) {}
    }
  }
  document.querySelectorAll(`.video-tile[data-peer="${peerAttr}"]`).forEach((el) => el.remove());
  // One tile per remote peer (2-person UI: you + them). Screen wins over camera; merge audio from both.
  if (hasOutVid || hasOutAud) {
    appendRemoteVideoTile(pid, displayStream, {
      feed: hasScrVid ? 'screen' : 'camera',
      preserveAudioEl,
    });
  }
  const remoteCountAfter = grid() ? grid().querySelectorAll('.video-tile[data-peer]:not(.local)').length : 0;
  if (remoteCountAfter > remoteCountBefore && remoteCountAfter >= 2) call('clearVideoFocus');
  call('applyVideoGridFocus');
  try {
    call('updateParticipantsList');
  } catch (_) {}
}

function wireRemoteStreamDynamicTracks(peerId, stream, feedHint) {
  if (!stream || remoteStreamsTrackWired.has(stream)) return;
  remoteStreamsTrackWired.add(stream);
  const bump = () => scheduleRebuildRemotePeerPgm(peerId);
  const peerAttrEsc =
    typeof CSS !== 'undefined' && CSS.escape
      ? CSS.escape(String(peerId))
      : String(peerId).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  /** Full tile rebuild on track unmute was tearing down remote video repeatedly (both directions stayed black). Only nudge play when frames start. */
  function nudgePlayOnVideoTrack(t) {
    if (!t || t.kind !== 'video') return;
    const kick = () => {
      try {
        document
          .querySelectorAll(`.video-tile[data-peer="${peerAttrEsc}"] video`)
          .forEach((el) => {
            try {
              el.play();
            } catch (_) {}
          });
      } catch (_) {}
    };
    t.addEventListener('unmute', kick);
  }
  /** When the last video track in this remote stream ends, clear PGM slot even if PeerJS has not fired `call.close` yet (common when sender stops display capture). */
  function bindVideoEndedForPgmSlot(t) {
    if (!t || t.kind !== 'video') return;
    t.addEventListener('ended', () => {
      try {
        const live = stream.getVideoTracks().filter((x) => x && x.readyState !== 'ended');
        if (live.length === 0) {
          const pid = norm(peerId);
          const ent = call('getRemotePgmStreamsMap').get(pid) || { av: null, screen: null };
          if (feedHint === 'unified') {
            ent.av = null;
            ent.screen = null;
          } else {
            const slot = feedHint === 'screen' ? 'screen' : 'av';
            ent[slot] = null;
          }
          call('getRemotePgmStreamsMap').set(pid, ent);
        }
      } catch (_) {}
      bump();
    });
  }
  try {
    stream.getVideoTracks().forEach((t) => {
      nudgePlayOnVideoTrack(t);
      bindVideoEndedForPgmSlot(t);
    });
  } catch (_) {}
  stream.addEventListener('addtrack', (ev) => {
    try {
      nudgePlayOnVideoTrack(ev.track);
      bindVideoEndedForPgmSlot(ev.track);
    } catch (_) {}
    bump();
  });
  stream.addEventListener('removetrack', bump);
}

function addRemoteVideo(peerId, stream, feedHint) {
  try {
    call('clearRemoteSharingIntent', [peerId]);
  } catch (_) {}
  if (!stream) {
    scheduleRebuildRemotePeerPgm(peerId);
    return;
  }
  if (feedHint === 'unified') {
    call('updateRemoteUnifiedPgmStream', [peerId, stream]);
    wireRemoteStreamDynamicTracks(peerId, stream, 'unified');
  } else {
    const hint = feedHint === 'screen' ? 'screen' : 'camera';
    call('updateRemotePgmStreamRef', [peerId, stream, hint]);
    wireRemoteStreamDynamicTracks(peerId, stream, hint);
  }
  scheduleRebuildRemotePeerPgm(peerId);
  try {
    call('sendGrigsiHelloToPeer', [peerId]);
  } catch (_) {}
  try {
    const np = norm(peerId);
    [0, 50, 200, 600, 1400].forEach((ms) => {
      setTimeout(() => {
        try {
          call('refreshRemoteVideoMirrorForPeer', [np]);
        } catch (_) {}
      }, ms);
    });
  } catch (_) {}
}

function appendRemoteVideoTile(peerId, stream, opts) {
  const rawFeed = opts && opts.feed;
  const feed =
    rawFeed === 'screen' ? 'screen' : rawFeed === 'camera' ? 'camera' : rawFeed === 'pgm' ? 'pgm' : '';
  const vids = stream
    .getVideoTracks()
    .filter((t) => t && t.readyState !== 'ended' && !call('isMeshPlaceholderVideoTrack', [t]));
  const auds = stream.getAudioTracks().filter((t) => t && t.readyState !== 'ended');
  if (!vids.length && !auds.length) return;

  const tile = document.createElement('div');
  tile.className = 'video-tile';
  tile.dataset.peer = String(peerId);
  if (feed) tile.dataset.feed = feed;

  const audioOnlyTile = vids.length === 0 && auds.length > 0;
  if (audioOnlyTile) tile.classList.add('video-tile--audio-only');
  const videoStream = new MediaStream(vids);
  const audioStream = auds.length ? new MediaStream(auds) : null;

  const video = document.createElement('video');
  // Remote camera: always try the full incoming MediaStream first (matches Chrome-as-receiver). Firefox-as-receiver
  // used to prefer video-only first and often stayed black on Chrome→Firefox; swap to video-only if no frames decode.
  if (audioOnlyTile) {
    video.style.display = 'none';
  } else if (feed !== 'screen' && vids.length > 0) {
    const primary = stream;
    const secondary = videoStream;
    try {
      video.srcObject = primary;
    } catch (_) {
      try {
        video.srcObject = videoStream;
      } catch (_) {}
    }
    const trySwapIfStillBlack = () => {
      try {
        if (video.videoWidth === 0 && secondary) {
          video.srcObject = secondary;
          video.play().catch(() => {});
        }
      } catch (_) {}
    };
    setTimeout(trySwapIfStillBlack, 350);
    setTimeout(trySwapIfStillBlack, 1200);
    try {
      video.play().catch(() => {});
    } catch (_) {}
  } else {
    video.srcObject = videoStream;
  }
  // Play video-only on <video> (muted) and audio on a separate <audio> so autoplay policy does not block
  // the picture when both mic and camera are in the same remote MediaStream.
  video.muted = true;
  video.autoplay = true;
  video.playsInline = true;
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  const shell = document.createElement('div');
  shell.className = 'remote-video-shell';
  if (!audioOnlyTile) shell.appendChild(video);
  if (!audioOnlyTile) {
    try {
      call('applyRemoteCameraMirrorToVideoEl', [video, peerId, feed, stream, shell]);
    } catch (_) {}
  }

  let audioEl = opts && opts.preserveAudioEl ? opts.preserveAudioEl : null;
  if (!audioEl && audioStream && audioStream.getAudioTracks().length) {
    audioEl = document.createElement('audio');
    audioEl.className = 'remote-peer-audio';
    audioEl.autoplay = true;
    audioEl.srcObject = audioStream;
    audioEl.setAttribute('playsinline', '');
    audioEl.setAttribute('aria-hidden', 'true');
    audioEl.style.cssText = 'position:absolute;width:0;height:0;opacity:0;pointer-events:none;left:0;top:0';
  }

  const participant = (call('getParticipants') || []).find((p) => p.id === peerId);
  const name = participant ? participant.name : 'Participant';

  const removeBtn = document.createElement('button');
  removeBtn.type = 'button';
  removeBtn.className = 'video-tile-remove';
  removeBtn.title = 'Stop video and audio from this participant (they stay in the Space)';
  removeBtn.dataset.peer = String(peerId);
  appendIcon(removeBtn, 'fas fa-times');
  const nameEl = document.createElement('div');
  nameEl.className = 'participant-name';
  let nameText = String(name || 'Participant');
  if (feed === 'screen' || (feed === 'pgm' && call('isDisplayCaptureStream', [stream]))) nameText = `${nameText} — Screen`;
  else if (feed === 'camera') nameText = `${nameText} — Camera`;
  nameEl.textContent = nameText;

  if (!audioOnlyTile) tile.appendChild(shell);
  if (audioEl) tile.appendChild(audioEl);
  try {
    vids.forEach((t) => {
      if (!t) return;
      const nudge = () => {
        try {
          video.play();
        } catch (_) {}
      };
      t.addEventListener('unmute', nudge);
      t.addEventListener('ended', nudge);
    });
  } catch (_) {}
  const showRemoteDesktopUi = feed === 'screen' || call('isDisplayCaptureStream', [stream]) || !!call('getSharesScreen', [peerId]);
  if (showRemoteDesktopUi) {
    const overlay = document.createElement('div');
    overlay.className = 'remote-video-control-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    tile.appendChild(overlay);
    call('bindRemoteOverlayPointer', [overlay, video, peerId]);
    call('setupRemoteVideoControlBar', [tile, peerId, video]);
  }
  tile.appendChild(removeBtn);
  tile.appendChild(nameEl);

  const npMirror = norm(peerId);
  const tryPlayRemote = () => {
    if (!audioOnlyTile) {
      try {
        video.play();
      } catch (_) {}
    }
    if (audioEl) {
      try {
        audioEl.play();
      } catch (_) {}
    }
    if (!audioOnlyTile) {
      try {
        call('refreshRemoteVideoMirrorForPeer', [npMirror]);
      } catch (_) {}
    }
  };
  tryPlayRemote();
  if (!audioOnlyTile) {
    video.addEventListener('loadedmetadata', tryPlayRemote);
    video.addEventListener('canplay', tryPlayRemote);
    [0, 120, 400, 1000].forEach((ms) => {
      setTimeout(() => {
        try {
          call('refreshRemoteVideoMirrorForPeer', [npMirror]);
        } catch (_) {}
      }, ms);
    });
  }
  try {
    auds.forEach((t) => {
      if (!t) return;
      t.addEventListener('unmute', tryPlayRemote);
      t.addEventListener('ended', tryPlayRemote);
    });
  } catch (_) {}
  Promise.resolve().then(tryPlayRemote).catch(() => {});

  if (removeBtn) {
    removeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (confirm('Stop receiving video and audio from this participant? They remain in the Space.')) call('stopRemoteVideoStream', [peerId]);
    });
  }

  const vg = grid();
  if (!vg) return;
  vg.appendChild(tile);
  call('kickRemotePeerAudioPlayback');
  call('ensureRemoteAudioKeepalive');
  try {
    const feedKind = audioOnlyTile ? 'audio' : feed === 'screen' ? 'screen' : 'video';
    window.GriGsiSpaceChatNotices?.markReady(
      peerId,
      feedKind,
      feedKind === 'screen'
        ? 'Their screen is live.'
        : feedKind === 'audio'
          ? 'Voice is live — listen in this chat.'
          : 'Their stream is live.'
    );
  } catch (_) {}
  try {
    call('tryAutoPresentRemoteMedia', [peerId]);
  } catch (_) {}
}
  function installSpaceBridge(context) {
    ctx = context && typeof context === "object" ? context : {};
    const bridge = {
      scheduleRebuildRemotePeerPgm,
      rebuildRemotePeerPgmTile,
      patchRemotePeerTileVideoOnly,
      wireRemoteStreamDynamicTracks,
      cleanupRemotePgmSchedulersForPeer,
      addRemoteVideo,
    };
    global.GriGsiSpaceRemotePgmTiles = {
      installSpaceBridge,
      ...bridge,
    };
    return bridge;
  }

  global.GriGsiSpaceRemotePgmTiles = { installSpaceBridge };
})(typeof window !== "undefined" ? window : globalThis);

;
"use strict";

/** Device label only (sessionStorage) — replaces GriGsiConnect for local-first UI. */
(function (global) {
  const KEY = "grigsi_device_label";

  function getDisplayName() {
    try {
      return global.sessionStorage.getItem(KEY) || "";
    } catch (_) {
      return "";
    }
  }

  function setDisplayName(name) {
    try {
      global.sessionStorage.setItem(KEY, String(name || "").trim().slice(0, 48));
    } catch (_) {}
  }

  global.GriGsiConnectDeviceLabel = { getDisplayName, setDisplayName };
})(typeof window !== "undefined" ? window : global);

;
"use strict";

/**
 * Etap 2 — offline-first UX: probe server, show banner, default local_first when unreachable.
 */
(function (global) {
  let serverReachable = null;
  let config = {
    ok: true,
    local_first: true,
    account_connect: false,
    cap_relay: false,
    lan_beacon: false,
    offline_assumed: true,
  };

  const PROBE_TIMEOUT_MS = 8000;
  const PROBE_ATTEMPTS = 2;
  const RECHECK_MS = 25000;

  async function probeOnce() {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), PROBE_TIMEOUT_MS);
    try {
      const res = await fetch("/api/connect/config", { cache: "no-store", signal: ctrl.signal });
      clearTimeout(timer);
      const data = await res.json().catch(() => ({}));
      if (res.ok && data && data.ok) return data;
    } catch (_) {
      clearTimeout(timer);
    }
    return null;
  }

  async function probeConfig() {
    if (!global.navigator.onLine) {
      serverReachable = false;
      config = Object.assign({}, config, { offline_assumed: true, offline: true });
      return config;
    }
    // One unlucky probe used to mark the server unreachable for the whole
    // session (no re-check). Retry a couple times before giving up; the
    // periodic recheck below then recovers on its own.
    for (let i = 0; i < PROBE_ATTEMPTS; i++) {
      const data = await probeOnce();
      if (data) {
        serverReachable = true;
        config = Object.assign({ offline_assumed: false }, data);
        return config;
      }
      if (i < PROBE_ATTEMPTS - 1) {
        await new Promise((r) => setTimeout(r, 1200));
      }
    }
    serverReachable = false;
    config = {
      ok: true,
      local_first: true,
      account_connect: false,
      cap_relay: false,
      lan_beacon: false,
      space_push: false,
      deep_link_scheme: "grigsi",
      offline_assumed: true,
      offline: true,
    };
    return config;
  }

  function isServerReachable() {
    if (serverReachable === null) return true;
    return serverReachable === true;
  }

  function getConfig() {
    return config;
  }

  function bannerMessage() {
    if (!global.navigator.onLine) {
      return "Offline — saved list works on this device. Starting new instant sessions needs the network.";
    }
    if (serverReachable === false) {
      return "Server unreachable — your saved list still works here. New instant sessions need the network.";
    }
    return "";
  }

  function renderBanner() {
    const msg = bannerMessage();
    const ids = ["connect-offline-banner", "space-offline-banner"];
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (!el) return;
      if (!msg) {
        el.classList.add("hidden");
        el.textContent = "";
        return;
      }
      el.classList.remove("hidden");
      el.textContent = msg;
    });
  }

  let recheckTimer = null;

  function applyStatusPill() {
    const status = document.getElementById("gsi-entry-status");
    if (!status) return;
    if (config && config.offline_assumed) {
      status.textContent = "Offline";
      status.className = "gsi-entry-status gsi-st-warn";
    } else {
      status.textContent = "Online";
      status.className = "gsi-entry-status";
    }
  }

  function runProbe() {
    return probeConfig().then(() => {
      renderBanner();
      applyStatusPill();
    });
  }

  function init() {
    void runProbe();
    // Keep re-checking so a single transient blip (or a busy moment on the
    // server) does not leave "Server unreachable" stuck for the whole session.
    if (!recheckTimer) {
      recheckTimer = setInterval(() => {
        if (global.navigator.onLine) void runProbe();
      }, RECHECK_MS);
    }
    global.addEventListener("online", () => {
      void runProbe();
    });
    global.addEventListener("offline", () => {
      serverReachable = false;
      config.offline_assumed = true;
      renderBanner();
      applyStatusPill();
    });
    // Re-check promptly when the user comes back to the tab.
    global.document &&
      global.document.addEventListener("visibilitychange", () => {
        if (!global.document.hidden && global.navigator.onLine) void runProbe();
      });
  }

  global.GriGsiConnectOffline = {
    probeConfig,
    isServerReachable,
    getConfig,
    renderBanner,
    init,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(typeof window !== "undefined" ? window : global);

;
"use strict";

/**
 * Etap 3C — cap one-time consume coordinated over open PeerJS data channels (no server relay).
 */
(function (global) {
  const MSG_TYPE = "cap_relay";
  const QUERY_MS = 2400;
  const INSTANCE_KEY = "grigsi_cap_p2p_inst";

  let bridge = null;
  const pendingQueries = Object.create(null);
  const peerSpentJti = new Set();

  function instanceId() {
    try {
      let id = global.sessionStorage.getItem(INSTANCE_KEY);
      if (!id) {
        id = "cpi_" + Math.random().toString(36).slice(2, 10);
        global.sessionStorage.setItem(INSTANCE_KEY, id);
      }
      return id;
    } catch (_) {
      return "cpi_anon";
    }
  }

  function isAvailable() {
    return !!(bridge && bridge.hasOpenPeers && bridge.hasOpenPeers());
  }

  function attachSpaceBridge(b) {
    bridge = b;
  }

  function markJtiSpent(jti) {
    if (!jti) return;
    peerSpentJti.add(String(jti));
    const SB = global.GriGsiSpaceBook || global.GriGsiConnectLocalMode;
    if (SB && SB.markCapJtiConsumed) void SB.markCapJtiConsumed(jti);
  }

  function handleIncoming(peerId, data) {
    if (!data || data.type !== MSG_TYPE) return;
    const SB = global.GriGsiSpaceBook || global.GriGsiConnectLocalMode;
    const jti = data.jti ? String(data.jti) : "";

    if (data.action === "query" && jti) {
      let consumed = peerSpentJti.has(jti);
      if (!consumed && SB && SB.isCapJtiConsumed) consumed = SB.isCapJtiConsumed(jti);
      if (bridge && bridge.sendToPeer) {
        bridge.sendToPeer(peerId, {
          type: MSG_TYPE,
          action: "reply",
          jti,
          consumed: !!consumed,
          from: instanceId(),
        });
      }
      return;
    }

    if (data.action === "reply" && jti) {
      const p = pendingQueries[jti];
      if (p && data.consumed) {
        p.consumed = true;
        clearTimeout(p.timer);
        delete pendingQueries[jti];
        p.resolve({ ok: true, consumed: true, peers: p.replies.size, p2p: true });
      } else if (p) {
        p.replies.add(peerId);
      }
      return;
    }

    if (data.action === "spent" && jti) {
      markJtiSpent(jti);
      const p = pendingQueries[jti];
      if (p) {
        clearTimeout(p.timer);
        delete pendingQueries[jti];
        p.resolve({ ok: true, consumed: true, peers: p.replies.size, p2p: true });
      }
    }
  }

  function requestConsumeCheck(payload) {
    const jti = payload && payload.jti ? String(payload.jti) : "";
    if (!jti) return Promise.resolve({ ok: true, consumed: false, peers: 0 });
    if (peerSpentJti.has(jti)) {
      return Promise.resolve({ ok: true, consumed: true, peers: 0, p2p: true });
    }
    const SB = global.GriGsiSpaceBook || global.GriGsiConnectLocalMode;
    if (SB && SB.isCapJtiConsumed && SB.isCapJtiConsumed(jti)) {
      return Promise.resolve({ ok: true, consumed: true, peers: 0, local: true });
    }
    if (!isAvailable()) {
      return Promise.resolve({ ok: true, consumed: false, peers: 0, skipped: true });
    }

    return new Promise((resolve) => {
      const entry = {
        replies: new Set(),
        consumed: false,
        resolve,
        timer: setTimeout(() => {
          delete pendingQueries[jti];
          resolve({
            ok: true,
            consumed: !!entry.consumed,
            peers: entry.replies.size,
            p2p: true,
          });
        }, QUERY_MS),
      };
      pendingQueries[jti] = entry;
      bridge.sendToAll({
        type: MSG_TYPE,
        action: "query",
        jti,
        from: instanceId(),
      });
    });
  }

  function announceConsumed(payload) {
    const jti = payload && payload.jti ? String(payload.jti) : "";
    if (!jti) return;
    markJtiSpent(jti);
    if (!bridge || !bridge.sendToAll) return;
    bridge.sendToAll({
      type: MSG_TYPE,
      action: "spent",
      jti,
      from: instanceId(),
    });
  }

  global.GriGsiCapP2pRelay = {
    MSG_TYPE,
    attachSpaceBridge,
    isAvailable,
    requestConsumeCheck,
    announceConsumed,
    handleIncoming,
    markJtiSpent,
  };
})(typeof window !== "undefined" ? window : global);

;
"use strict";

/**
 * Etap 3 — signed link (cap) behaviour: online relay vs offline local-only consume.
 */
(function (global) {
  const HINT_OFFLINE =
    "Link accepted on this device only. With peers connected in Space, one-time links sync over P2P; otherwise the GriGsi server when online.";
  const HINT_P2P =
    "Link checked with peers in this Space (P2P). Global burn also sent to server when available.";
  const HINT_RELAY_OK =
    "Link confirmed with the server — one-time use is enforced globally.";
  const HELP_HTML =
    "<p><strong>Fixed-term</strong> — access until the date you set; files + history.</p>" +
    "<p><strong>One-time session</strong> — until session ends; may be stored in Spacebook.</p>" +
    "<p><strong>10 Actions</strong> — up to 10 operations (join, chat, files, video, screen).</p>" +
    "<p><strong>Trusted</strong> — saved in SpaceBook on this device only.</p>" +
    "<p><strong>Offline / server down:</strong> the signature is still checked here; " +
    "used links are remembered locally. Another person could reuse the same link until the server is back.</p>" +
    "<p><strong>Online:</strong> one-time links are burned on the server (hash only — not your SpaceBook).</p>" +
    "<p><strong>P2P (3C):</strong> if you are in a Space with another peer, cap consume is coordinated over the data channel before/along server relay.</p>";

  function messageAfterClaim(result) {
    if (!result || !result.ok) return "";
    if (result.p2p && result.relay) return HINT_P2P;
    if (result.offline || result.relay === false) return HINT_OFFLINE;
    if (result.relay) return HINT_RELAY_OK;
    return "";
  }

  function isServerRelayAvailable() {
    const off = global.GriGsiConnectOffline;
    if (off && typeof off.isServerReachable === "function") {
      return off.isServerReachable();
    }
    return global.navigator && global.navigator.onLine;
  }

  function setCapPolicyStatus(el, result) {
    if (!el) return;
    const msg = messageAfterClaim(result);
    if (!msg) {
      el.classList.add("hidden");
      el.textContent = "";
      return;
    }
    el.classList.remove("hidden");
    el.textContent = msg;
  }

  global.GriGsiConnectCapPolicy = {
    HINT_OFFLINE,
    HINT_RELAY_OK,
    HELP_HTML,
    messageAfterClaim,
    isServerRelayAvailable,
    setCapPolicyStatus,
  };
})(typeof window !== "undefined" ? window : global);

;
"use strict";

/**
 * Same Wi‑Fi / LAN: show share URL using current host (works for local IP dev servers).
 */
(function (global) {
  function isPrivateHost(hostname) {
    const h = String(hostname || "").toLowerCase();
    if (h === "localhost" || h.endsWith(".local")) return true;
    if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
    if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
    const m = /^172\.(\d{1,2})\.\d{1,3}\.\d{1,3}$/.exec(h);
    if (m) {
      const n = Number(m[1]);
      if (n >= 16 && n <= 31) return true;
    }
    return false;
  }

  function currentShareUrl() {
    try {
      return global.location.href.split("#")[0];
    } catch (_) {
      return "";
    }
  }

  function mountLanHint(containerId, copyBtnId) {
    const box = document.getElementById(containerId);
    if (!box) return;
    const host = global.location.hostname;
    if (!isPrivateHost(host)) {
      box.classList.add("hidden");
      return;
    }
    const url = currentShareUrl();
    const input = box.querySelector("input, .connect-lan-hint__url");
    if (input) {
      if (input.tagName === "INPUT") input.value = url;
      else input.textContent = url;
    }
    box.classList.remove("hidden");
    const copyBtn = document.getElementById(copyBtnId);
    if (copyBtn && url) {
      copyBtn.addEventListener("click", async () => {
        try {
          await navigator.clipboard.writeText(url);
          copyBtn.textContent = "Copied";
          setTimeout(() => {
            copyBtn.innerHTML = '<i class="fas fa-copy"></i> Copy LAN link';
          }, 2000);
        } catch (_) {
          global.prompt("Copy this link for others on the same network:", url);
        }
      });
    }
  }

  global.GriGsiConnectLanHint = {
    isPrivateHost,
    mountLanHint,
    currentShareUrl,
  };

  function init() {
    mountLanHint("connect-lan-hint", "btn-copy-lan-link");
    mountLanHint("space-lan-hint", "btn-space-copy-lan-link");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(typeof window !== "undefined" ? window : global);

;
"use strict";

/**
 * Phase 7 — grigsi:// deep links (web + Capacitor App URL).
 * grigsi://sendi/CODE | grigsi://connect | grigsi://open?sendi=CODE
 */
(function (global) {
  const SCHEME = "grigsi:";

  function normalizeCode(raw) {
    const book = global.GriGsiSpaceBook || global.GriGsiConnectLocalMode;
    if (book && book.normalizeCode) return book.normalizeCode(raw);
    return String(raw || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9-]/g, "")
      .slice(0, 24);
  }

  function buildSpaceUrl(code) {
    const S = global.GriGsiSpaceCodeParse;
    if (S && S.buildSpacePageUrl) return S.buildSpacePageUrl(code);
    const book = global.GriGsiSpaceBook;
    if (book && book.buildUrlFromCode) return book.buildUrlFromCode(code);
    return "/SENDi!/?sendi=" + encodeURIComponent(code);
  }

  function parseGrigsiUrl(urlStr) {
    try {
      const u = new URL(String(urlStr || "").trim());
      if (u.protocol !== SCHEME && !String(urlStr).trim().toLowerCase().startsWith(SCHEME)) {
        return null;
      }
      const host = (u.hostname || u.host || "").toLowerCase();
      const path = (u.pathname || "").replace(/^\/+/, "");
      if (host === "connect" || path === "connect") {
        return { ok: true, route: "/instant/", type: "connect" };
      }
      if (host === "space" || path.startsWith("space/")) {
        const code = normalizeCode(path.replace(/^space\/?/i, "") || u.searchParams.get("space"));
        if (code) return { ok: true, route: buildSpaceUrl(code), type: "space", space_code: code };
      }
      if (host === "open" || path === "open") {
        const code = normalizeCode(u.searchParams.get("space") || u.searchParams.get("code"));
        if (code) return { ok: true, route: buildSpaceUrl(code), type: "space", space_code: code };
        return { ok: true, route: "/instant/", type: "connect" };
      }
      const fallback = normalizeCode(host || path.split("/")[0]);
      if (fallback) {
        return { ok: true, route: buildSpaceUrl(fallback), type: "space", space_code: fallback };
      }
    } catch (_) {}
    return null;
  }

  function navigate(parsed) {
    if (!parsed || !parsed.ok || !parsed.route) return false;
    if (parsed.route.startsWith("http") || parsed.route.startsWith("/")) {
      global.location.href = parsed.route;
      return true;
    }
    return false;
  }

  function handleIncomingUrl(urlStr) {
    const parsed = parseGrigsiUrl(urlStr);
    if (parsed) return navigate(parsed);
    try {
      const u = new URL(urlStr, global.location.origin);
      if (u.searchParams.get("deeplink")) {
        return handleIncomingUrl(u.searchParams.get("deeplink"));
      }
    } catch (_) {}
    return false;
  }

  function wireCapacitorApp() {
    const Cap = global.Capacitor;
    const App = Cap && Cap.Plugins && Cap.Plugins.App;
    if (!App) return;
    if (App.getLaunchUrl) {
      App.getLaunchUrl()
        .then((r) => {
          if (r && r.url) handleIncomingUrl(r.url);
        })
        .catch(() => {});
    }
    if (App.addListener) {
      App.addListener("appUrlOpen", (ev) => {
        if (ev && ev.url) handleIncomingUrl(ev.url);
      });
    }
  }

  function boot() {
    const q = new URLSearchParams(global.location.search);
    const dl = q.get("deeplink") || q.get("grigsi");
    if (dl) handleIncomingUrl(dl);
    wireCapacitorApp();
  }

  global.GriGsiConnectDeepLink = {
    parseGrigsiUrl,
    handleIncomingUrl,
    buildSpaceUrl,
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})(typeof window !== "undefined" ? window : global);

;
/**
 * GriGsi Connect — deterministic geometric visual marks (no emoji).
 * Same seed → same gradient + abstract glyph. Privacy-first: derived from profile id / code only.
 */
(function (global) {
  "use strict";

  const GLYPHS = ["◆", "◇", "△", "▽", "○", "●", "■", "□", "◈", "◊", "◎", "◐", "◑", "◒", "◓", "◢", "◣", "◤", "◥", "⬡", "⬢", "◧", "◨", "◩"];

  function hashSeed(str) {
    let h = 2166136261;
    const s = String(str || "");
    for (let i = 0; i < s.length; i++) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return h >>> 0;
  }

  function deriveVisual(seed) {
    const raw = String(seed || "").trim().toUpperCase();
    const h = hashSeed(raw || "grigsi");
    const h2 = hashSeed(raw.toLowerCase() + ":accent");
    return {
      hue: h % 360,
      hue2: (h2 % 280) + 40,
      shape: h % 8,
      glyph: GLYPHS[h2 % GLYPHS.length],
      pattern: (h >> 3) % 4,
    };
  }

  function hsl(h, s, l) {
    return "hsl(" + h + "," + s + "%," + l + "%)";
  }

  function shapeLayer(v, gid) {
    const grad = "url(#" + gid + ")";
    const c1 = hsl(v.hue, 52, 42);
    const c2 = hsl(v.hue2, 48, 58);
    const stroke = hsl(v.hue, 40, 28);
    const s = v.shape;
    if (s === 0) {
      return (
        '<circle cx="16" cy="16" r="11" fill="' + grad + '" opacity="0.92"/>' +
        '<circle cx="16" cy="16" r="11" fill="none" stroke="' + stroke + '" stroke-width="1.2" opacity="0.55"/>' +
        '<circle cx="16" cy="16" r="3.5" fill="' + c2 + '" opacity="0.95"/>'
      );
    }
    if (s === 1) {
      return '<polygon points="16,5 27,24 5,24" fill="' + grad + '" stroke="' + stroke + '" stroke-width="1" opacity="0.94"/>';
    }
    if (s === 2) {
      return '<rect x="8" y="8" width="16" height="16" rx="2" transform="rotate(45 16 16)" fill="' + grad + '" stroke="' + stroke + '" stroke-width="1" opacity="0.94"/>';
    }
    if (s === 3) {
      return '<polygon points="16,4 26,10 26,22 16,28 6,22 6,10" fill="none" stroke="' + c1 + '" stroke-width="2.2" opacity="0.9"/>' +
        '<polygon points="16,8 22,12 22,20 16,24 10,20 10,12" fill="' + grad + '" opacity="0.75"/>';
    }
    if (s === 4) {
      return '<circle cx="12" cy="16" r="7" fill="' + c1 + '" opacity="0.82"/>' +
        '<circle cx="20" cy="16" r="7" fill="' + c2 + '" opacity="0.72"/>';
    }
    if (s === 5) {
      return '<path d="M6 18 A10 10 0 0 1 26 18 Z" fill="' + grad + '" opacity="0.9"/>' +
        '<path d="M8 18 A8 8 0 0 0 24 18" fill="none" stroke="' + stroke + '" stroke-width="1.2" opacity="0.5"/>';
    }
    if (s === 6) {
      return '<rect x="14" y="6" width="4" height="20" rx="1" fill="' + c1 + '" opacity="0.9"/>' +
        '<rect x="6" y="14" width="20" height="4" rx="1" fill="' + c2 + '" opacity="0.88"/>';
    }
    return (
      '<circle cx="11" cy="11" r="3.2" fill="' + c1 + '"/>' +
      '<circle cx="21" cy="11" r="3.2" fill="' + c2 + '"/>' +
      '<circle cx="11" cy="21" r="3.2" fill="' + c2 + '" opacity="0.85"/>' +
      '<circle cx="21" cy="21" r="3.2" fill="' + c1 + '" opacity="0.8"/>'
    );
  }

  function defs(v, gid) {
    return (
      "<defs>" +
      '<linearGradient id="' + gid + '" x1="0%" y1="0%" x2="100%" y2="100%">' +
      '<stop offset="0%" stop-color="' + hsl(v.hue, 56, 48) + '"/>' +
      '<stop offset="100%" stop-color="' + hsl(v.hue2, 50, 62) + '"/>' +
      "</linearGradient></defs>"
    );
  }

  function buildSvgMarkup(seed, dim) {
    const v = deriveVisual(seed);
    const d = dim || 40;
    const gid = "cmg-" + hashSeed(String(seed || "grigsi"));
    const glyph = v.glyph;
    return (
      '<svg class="connect-mark__svg" viewBox="0 0 32 32" width="' + d + '" height="' + d + '" aria-hidden="true">' +
      defs(v, gid) +
      shapeLayer(v, gid) +
      '<text x="16" y="17" text-anchor="middle" dominant-baseline="middle" class="connect-mark__glyph" font-size="9" fill="rgba(255,255,255,0.92)">' +
      glyph +
      "</text></svg>"
    );
  }

  function seedFromProfile(prof) {
    if (!prof) return "";
    if (prof.profile_id) return String(prof.profile_id);
    if (prof.display_code) return String(prof.display_code);
    if (prof.code_prefix && prof.code_suffix) return prof.code_prefix + "-" + prof.code_suffix;
    if (prof.anchor_suffix) return String(prof.anchor_suffix);
    return "";
  }

  function seedFromCode(code) {
    return String(code || "").trim();
  }

  function createMarkElement(seed, opts) {
    opts = opts || {};
    const size = opts.size || "md";
    const dim = size === "sm" ? 28 : size === "lg" ? 52 : size === "xs" ? 22 : 40;
    const v = deriveVisual(seed);
    const el = document.createElement("span");
    el.className = "connect-mark connect-mark--" + size + (opts.temporary ? " connect-mark--temp" : "");
    if (opts.title) el.setAttribute("title", opts.title);
    el.setAttribute("role", opts.decorative === false ? "img" : "presentation");
    if (opts.decorative === false && opts.label) el.setAttribute("aria-label", opts.label);
    el.style.setProperty("--cm-hue", String(v.hue));
    el.style.setProperty("--cm-hue2", String(v.hue2));
    el.innerHTML = buildSvgMarkup(seed, dim);
    return el;
  }

  function paintMark(container, seed, opts) {
    if (!container) return null;
    container.innerHTML = "";
    const el = createMarkElement(seed, opts);
    container.appendChild(el);
    return el;
  }

  function accentColor(seed) {
    const v = deriveVisual(seed);
    return hsl(v.hue, 52, 48);
  }

  const SEEN_KEY = "grigsi_connect_seen";

  function readSeenSet() {
    try {
      const raw = localStorage.getItem(SEEN_KEY);
      const arr = raw ? JSON.parse(raw) : [];
      return new Set(Array.isArray(arr) ? arr : []);
    } catch (_) {
      return new Set();
    }
  }

  function writeSeenSet(set) {
    try {
      const arr = Array.from(set).slice(-120);
      localStorage.setItem(SEEN_KEY, JSON.stringify(arr));
    } catch (_) {}
  }

  function seenKey(seed) {
    return String(seed || "").trim().toLowerCase();
  }

  function recordSeen(seed) {
    const k = seenKey(seed);
    if (!k) return;
    const set = readSeenSet();
    set.add(k);
    writeSeenSet(set);
  }

  function hasSeenBefore(seed) {
    const k = seenKey(seed);
    if (!k) return false;
    return readSeenSet().has(k);
  }

  global.GriGsiConnectVisual = {
    deriveVisual,
    buildSvgMarkup,
    seedFromProfile,
    seedFromCode,
    createMarkElement,
    paintMark,
    accentColor,
    recordSeen,
    hasSeenBefore,
  };
})(typeof window !== "undefined" ? window : this);

;
"use strict";

/**
 * Space URL/enter parsing — plain space secret in links; server uses SHA-256 space key only.
 */
(function (global) {
  function queryRoomKey(params) {
    if (!params || typeof params.get !== "function") return "";
    const inv = String(params.get("invite") || "").trim();
    if (inv) return inv;
    const sendi = String(params.get("sendi") || "").trim();
    if (sendi && !/^(1|true)$/i.test(sendi)) return sendi;
    return String(params.get("space") || params.get("code") || "").trim();
  }

  function extractCandidate(rawValue) {
    const raw = String(rawValue || "").trim();
    if (!raw) return "";
    if (/^grigsi:/i.test(raw)) {
      try {
        const u = new URL(raw);
        const host = (u.hostname || u.host || "").toLowerCase();
        const path = (u.pathname || "").replace(/^\/+/, "");
        const fromQuery = queryRoomKey(u.searchParams);
        if (fromQuery) return fromQuery;
        if (host === "space" || /^space\//i.test(path)) {
          const fromPath = path.replace(/^space\/?/i, "").trim();
          if (fromPath) return fromPath;
        }
        if (host === "open") return "";
        const fallback = (host || path.split("/")[0] || "").trim();
        if (fallback && fallback !== "connect") return fallback;
      } catch (_) {}
    }
    if (/^https?:\/\//i.test(raw)) {
      try {
        const u = new URL(raw);
        return queryRoomKey(u.searchParams);
      } catch (_) {}
    }
    if (/space\.html/i.test(raw) || /[?&](?:code|space|sendi|invite)=/i.test(raw)) {
      try {
        const u = new URL(raw, global.location?.origin || "https://grigsi.com");
        return queryRoomKey(u.searchParams);
      } catch (_) {
        const mInvite = raw.match(/[?&]invite=([^&#]+)/i);
        if (mInvite) {
          try {
            return decodeURIComponent(mInvite[1].replace(/\+/g, " ")).trim();
          } catch (_) {
            return String(mInvite[1]).trim();
          }
        }
        const m = raw.match(/[?&](?:invite|sendi|code|space)=([^&#]+)/i);
        if (m) {
          try {
            return decodeURIComponent(m[1].replace(/\+/g, " ")).trim();
          } catch (_) {
            return String(m[1]).trim();
          }
        }
      }
    }
    return raw;
  }

  function secretFromInput(rawValue) {
    const raw = extractCandidate(rawValue);
    const RK = global.GriGsiSpaceSecret;
    if (RK && RK.normalizeTimedInput) return RK.normalizeTimedInput(raw);
    return raw;
  }

  /** @deprecated use secretFromInput — kept for callers expecting canonicalFromInput */
  function canonicalFromInput(rawValue) {
    return secretFromInput(rawValue);
  }

  function spaceHtmlPath(opts) {
    const o = opts && typeof opts === "object" ? opts : {};
    if (o.shell === "minimal" || o.module === "find") return "/sendi/sendi-shell-find.html";
    if (o.sendi || o.product === "sendi") return "/SENDi!/";
    try {
      const p = decodeURIComponent(String((global.location && global.location.pathname) || ""));
      if (/^\/SENDi!?\/?$/i.test(p) || /^\/sendi\/?$/i.test(p)) return "/SENDi!/";
    } catch (_) {}
    return "/SENDi!/";
  }

  function routePathFromSecret(secret, opts) {
    if (!secret) return spaceHtmlPath(opts);
    return spaceHtmlPath(opts) + "?sendi=" + encodeURIComponent(secret);
  }

  function routePathFromCanonical(secret) {
    return routePathFromSecret(secret);
  }

  function buildSpacePageUrl(secret, opts) {
    const o = opts && typeof opts === "object" ? opts : {};
    let origin = "https://grigsi.com";
    try {
      if (global.location && global.location.origin) origin = global.location.origin;
    } catch (_) {}
    const RK = global.GriGsiSpaceSecret;
    const s = secretFromInput(secret);
    if (!s) return origin + spaceHtmlPath(o);
    const u = new URL(spaceHtmlPath(o), origin);
    const IT = global.GriGsiSpaceInviteTicket;
    if (RK && RK.isTimedSpaceSecret && RK.isTimedSpaceSecret(s)) {
      u.searchParams.set("invite", s);
    } else {
      u.searchParams.set("sendi", s);
    }
    if (o.module) u.searchParams.set("module", String(o.module));
    if (o.shell) u.searchParams.set("shell", String(o.shell));
    if (o.connectPeer) u.searchParams.set("connectPeer", String(o.connectPeer));
    if (o.peer) u.searchParams.set("connectPeer", String(o.peer));
    if (o.autoseek) u.searchParams.set("autoseek", String(o.autoseek));
    if (o.vq) u.searchParams.set("vq", String(o.vq));
    if (o.joinToken) u.searchParams.set("joinToken", String(o.joinToken));
    if (o.pick) u.searchParams.set("pick", String(o.pick));
    if (o.from) u.searchParams.set("from", String(o.from));
    return u.toString();
  }

  function isQuickSecret(secret) {
    const RK = global.GriGsiSpaceSecret;
    return RK ? RK.isTimedSpaceSecret(secret) : false;
  }

  /** @deprecated */
  function isQuickCode(secret) {
    return isQuickSecret(secret);
  }

  function normalizeCode(raw) {
    return secretFromInput(raw);
  }

  function navUrlFromInput(rawValue, opts) {
    const o = opts && typeof opts === "object" ? opts : {};
    const raw = String(rawValue || "").trim();
    if (!raw) return "";
    let origin = "https://grigsi.com";
    try {
      if (global.location && global.location.origin) origin = global.location.origin;
    } catch (_) {}
    if (/^https?:\/\//i.test(raw) || /^grigsi:/i.test(raw)) {
      try {
        const u = new URL(raw, origin);
        const sc = queryRoomKey(u.searchParams);
        if (sc) return buildSpacePageUrl(sc, o);
        if (/\/space(\/|$)/i.test(u.pathname) || /space\.html/i.test(u.pathname)) {
          return origin + spaceHtmlPath(o);
        }
      } catch (_) {}
    }
    if (/space\.html/i.test(raw) || /^\/space\//i.test(raw) || /[?&](?:code|space)=/i.test(raw)) {
      const secret = secretFromInput(raw);
      if (secret) return buildSpacePageUrl(secret, o);
    }
    const secret = secretFromInput(raw);
    if (!secret) return "";
    return buildSpacePageUrl(secret, o);
  }

  function normalizeAlphaNum() {
    return "";
  }

  global.GriGsiSpaceCodeParse = {
    extractCandidate,
    secretFromInput,
    canonicalFromInput,
    spaceHtmlPath,
    routePathFromSecret,
    routePathFromCanonical,
    buildSpacePageUrl,
    navUrlFromInput,
    isQuickSecret,
    isQuickCode,
    normalizeCode,
    normalizeAlphaNum,
  };
})(typeof window !== "undefined" ? window : globalThis);

;
/**
 * GriGsi Connect — enter parser (browser).
 */
(function (global) {
  function parseDisplayCode(raw) {
    const s = String(raw || "").trim().replace(/\s+/g, "");
    const dash = s.indexOf("-");
    if (dash < 1 || dash >= s.length - 1) return null;
    const prefix = s.slice(0, dash).replace(/[\x00-\x1f\x7f]/g, "").trim();
    const suffix = s.slice(dash + 1).replace(/[\x00-\x1f\x7f]/g, "").trim();
    if (!prefix || !suffix) return null;
    const display_code = prefix + "-" + suffix;
    return { prefix, suffix, anchor: suffix, display_code };
  }

  function tryParseAsConnectCode(s) {
    const norm = String(s || "").trim().replace(/\s+/g, "");
    if (/^grigsi-/i.test(norm)) return null;
    const RK = global.GriGsiSpaceSecret;
    if (RK && RK.isTimedSpaceSecret && RK.normalizeTimedInput) {
      const timed = RK.normalizeTimedInput(norm);
      if (timed && RK.isTimedSpaceSecret(timed)) return null;
    }
    const parsed = parseDisplayCode(norm);
    if (!parsed) return null;
    return {
      ok: true,
      type: "connect_resolve",
      route: "/instant/?q=" + encodeURIComponent(parsed.display_code),
      display_code: parsed.display_code,
    };
  }

  function tryParseAsSpaceCode(s) {
    const S = global.GriGsiSpaceCodeParse;
    const RK = global.GriGsiSpaceSecret;
    const canonical = S ? S.canonicalFromInput(s) : "";
    if (!canonical) return null;
    if (RK && RK.isSpaceKeyHash && RK.isSpaceKeyHash(canonical)) {
      const route = S.routePathFromCanonical(canonical);
      return { ok: true, type: "space", route, space_code: canonical, space_secret: canonical };
    }
    if (RK && RK.isTimedSpaceSecret && !RK.isTimedSpaceSecret(canonical)) return null;
    const route = S.routePathFromCanonical(canonical);
    return {
      ok: true,
      type: "space",
      route,
      space_code: canonical,
      space_secret: canonical,
    };
  }

  function tryParseAsUrl(s) {
    if (
      !/^https?:\/\//i.test(s) &&
      !/^grigsi:/i.test(s) &&
      !s.includes("?") &&
      !/space\.html/i.test(s) &&
      !/^grigsi-connect:/i.test(s)
    ) {
      return null;
    }
    if (/^grigsi:/i.test(s)) {
      const S = global.GriGsiSpaceCodeParse;
      if (S && S.navUrlFromInput) {
        const nav = S.navUrlFromInput(s);
        const secret = S.secretFromInput ? S.secretFromInput(s) : "";
        if (nav && secret) {
          return { ok: true, type: "space", route: nav, space_code: secret, space_secret: secret };
        }
      }
      return null;
    }
    let u;
    try {
      const base = s.startsWith("http") ? s : "https://x/" + s.replace(/^\//, "");
      u = new URL(base);
    } catch (_) {
      return null;
    }
    const path = (u.pathname || "").toLowerCase();
    if (path.includes("/instant/join") || path.includes("/instant/")) {
      const code = u.searchParams.get("code") || u.searchParams.get("display") || u.searchParams.get("q");
      if (code) {
        const sp = tryParseAsSpaceCode(String(code).trim());
        if (sp) return sp;
        const c = tryParseAsConnectCode(String(code).trim());
        if (c) return c;
      }
    }
    const sc =
      u.searchParams.get("space") || u.searchParams.get("code") || "";
    if (sc) {
      const base = tryParseAsSpaceCode(sc);
      if (base && u.searchParams.get("cap")) {
        try {
          base.route = u.href.startsWith("http") ? u.href : u.pathname + u.search + (u.hash || "");
        } catch (_) {
          base.route = "/SENDi!/" + u.search;
        }
      }
      return base;
    }
    if (path.includes("/SENDi!/") || path.includes("space.html")) {
      const sc2 =
        u.searchParams.get("space") || u.searchParams.get("code") || "";
      if (sc2) return tryParseAsSpaceCode(sc2);
    }
    return null;
  }

  function parseConnectEnter(raw) {
    const input = String(raw || "").trim();
    if (!input) return { ok: false, error: "empty_input" };
    const compact = input.replace(/\s+/g, "");
    const url = tryParseAsUrl(compact) || tryParseAsUrl(input.trim());
    if (url) return url;
    const space = tryParseAsSpaceCode(input) || tryParseAsSpaceCode(compact);
    if (space) return space;
    const connect = tryParseAsConnectCode(compact);
    if (connect) return connect;
    if (/^grigsi-connect:/i.test(compact)) {
      return {
        ok: true,
        type: "connect_resolve",
        route: "/instant/?pair=" + encodeURIComponent(compact.replace(/^grigsi-connect:v1:pair:/i, "")),
      };
    }
    return { ok: false, error: "unrecognized_input" };
  }

  global.GriGsiConnectEnter = { parseConnectEnter, parseDisplayCode };
  global.GriGsiCommunicatorEnter = { parseCommunicatorEnter: parseConnectEnter };
})(typeof window !== "undefined" ? window : globalThis);
